import React, { useEffect, useMemo, useRef, useState } from 'react';
import Dashboard from './Dashboard';
import axios from 'axios';
import './App.css';
import './food.css';
import './Home.css';

const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;

  if (envUrl && envUrl.trim()) {
    const clean = envUrl.trim().replace(/\/+$/, '');
    return clean.endsWith('/api') ? clean : `${clean}/api`;
  }

  if (window.location.hostname === 'localhost') {
    return 'http://localhost:5002/api';
  }

  return `${window.location.origin}/api`;
};

const apiUrl = getApiBaseUrl();

const baseUrl =
  (process.env.REACT_APP_BASE_URL && process.env.REACT_APP_BASE_URL.replace(/\/+$/, '')) ||
  apiUrl.replace(/\/api$/, '');

const CATEGORY_OPTIONS = [
];

const ADD_NEW_CATEGORY_VALUE = '__add_new_category__';

const NAV_ITEMS = [
  { key: 'home', label: 'Home', icon: '🏠' },
  { key: 'products', label: 'Products', icon: '🍔' },
  { key: 'menu', label: 'Menu List', icon: '📋' },
  { key: 'offers', label: 'Offers', icon: '🏷️' },
  { key: 'settings', label: 'Settings', icon: '⚙️' },
];

const OFFER_TYPES = {
  bill_discount: {
    key: 'bill_discount',
    label: 'Bill Discount',
    icon: '🏷️',
    note: 'Flat ya percent discount bill par',
  },
  combo: {
    key: 'combo',
    label: 'Combo Set',
    icon: '🍔🥤',
    note: 'Burger + Fries + Coke jaisa combo',
  },
  bill_unlock_addon: {
    key: 'bill_unlock_addon',
    label: 'Bill Unlock Add-on',
    icon: '🔓',
    note: 'Bill amount par special add-on deal',
  },
  buy_x_get_y: {
    key: 'buy_x_get_y',
    label: 'Buy X Get Y',
    icon: '🎁',
    note: 'Buy 2 Burger, get Coke free/₹10',
  },
  time_slot_offer: {
    key: 'time_slot_offer',
    label: 'Time Slot Offer',
    icon: '⏰',
    note: 'Happy hour / slow hour offer',
  },
  progressive_unlock: {
    key: 'progressive_unlock',
    label: 'Progressive Unlock',
    icon: '🚀',
    note: '₹300, ₹500, ₹800 step rewards',
  },
  coin_reward: {
    key: 'coin_reward',
    label: 'Coins Reward',
    icon: '🪙',
    note: 'Bill amount ke percentage ke hisab se Shop Coins',
  },
};

const emptyProductForm = {
  id: null,
  name: '',
  price: '',
  cost_price: '',
  category: '',
  image: null,
  existingImage: '',
  trend_item: false,
  food_type: 'veg',
  availability: 'in_stock',
  description: '',
};

const emptyComboItem = {
  productId: '',
  quantity: 1,
};

const emptyProgressiveStep = {
  min_bill_amount: '',
  reward_label: '',
  reward_type: 'flat_price',
  reward_product_id: '',
  reward_value: '',
};

const emptyOfferForm = {
  id: null,
  offer_type: 'combo',
  offer_name: '',
  order_type: 'individual',

  min_purchasing_price: '',
  max_purchasing_price: '',
  group_size: '',
  family_size: '',

  discount_type: 'flat',
  discount_value: '',
  max_discount: '',

  // Percentage based loyalty coins reward
  // Vendor khud values enter karega. Koi hidden/default coin rule nahi.
  coin_earn_percent: '',
  coin_min_bill_amount: '',
  coin_min_earn: '',
  coin_max_earn_per_order: '',
  coin_value_rupees: '',
  coin_min_redeem: '',
  coin_max_redeem_per_order: '',
  coin_min_order_for_redeem: '',
  coin_expiry_days: '',

  combo_items: [
    { ...emptyComboItem },
    { ...emptyComboItem },
  ],
  combo_price: '',

  addon_product_id: '',
  addon_special_price: '',
  addon_original_price: '',
  addon_cost_price: '',
  limit_per_order: 1,

  buy_product_id: '',
  buy_quantity: 2,
  get_product_id: '',
  get_quantity: 1,
  reward_type: 'flat_price',
  reward_value: '',

  start_time: '',
  end_time: '',
  days_active: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],

  progressive_steps: [
    { ...emptyProgressiveStep },
    { ...emptyProgressiveStep },
  ],

  safety_mode: 'balanced',
  min_final_margin_percent: 15,

  is_active: true,

  offerItems: [{ product: '', value: '' }],
};

const defaultSettings = {
  enable_dine_in: true,
  enable_takeaway: true,
  enable_delivery: false,
  allow_cod: true,
  allow_online_payment: true,
  preparation_time: 20,
  packaging_fee: 0,
  delivery_fee: 0,
  min_order_amount: 0,
  delivery_radius_km: '',
  delivery_eta_min: '',
  delivery_eta_max: '',
  shop_open_time: '',
  shop_close_time: '',
  opening_time: '',
  closing_time: '',
};

const safeFlagToBool = (value, fallback = true) => {
  if (value === true) return true;
  if (value === false) return false;
  if (value === 1 || value === 0) return Number(value) === 1;

  const text = String(value ?? '').trim().toLowerCase();

  if (['1', 'true', 'yes', 'on', 'enabled', 'active'].includes(text)) return true;
  if (['0', 'false', 'no', 'off', 'disabled', 'inactive'].includes(text)) return false;

  return fallback;
};

const normalizeTimeValue = (value) => {
  if (!value) return '';

  const raw = String(value).trim();
  if (!raw) return '';

  let text = raw.includes('T') ? raw.split('T')[1] : raw;
  text = text.slice(0, 8);

  const match = text.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return '';

  const hour = Number(match[1]);
  const minute = Number(match[2]);

  if (!Number.isFinite(hour) || !Number.isFinite(minute)) return '';
  if (hour < 0 || hour > 23 || minute < 0 || minute > 59) return '';

  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
};

const formatTimeAmPm = (value) => {
  const normalized = normalizeTimeValue(value);
  if (!normalized) return 'Not set';

  const [hourText, minuteText] = normalized.split(':');
  const hour24 = Number(hourText);
  const minute = Number(minuteText);
  const suffix = hour24 >= 12 ? 'PM' : 'AM';
  const hour12 = hour24 % 12 || 12;

  return `${hour12}:${String(minute).padStart(2, '0')} ${suffix}`;
};



const getTime12Parts = (value) => {
  const normalized = normalizeTimeValue(value);

  if (!normalized) {
    return {
      hour: '',
      minute: '00',
      period: 'AM',
    };
  }

  const [hourText, minuteText] = normalized.split(':');
  const hour24 = Number(hourText);
  const period = hour24 >= 12 ? 'PM' : 'AM';
  const hour12 = hour24 % 12 || 12;

  return {
    hour: String(hour12),
    minute: String(Number(minuteText)).padStart(2, '0'),
    period,
  };
};

const buildTimeFrom12 = ({ hour, minute, period }) => {
  const hourNum = Number(hour);
  const minuteNum = Number(minute);
  const safePeriod = String(period || 'AM').toUpperCase() === 'PM' ? 'PM' : 'AM';

  if (!Number.isFinite(hourNum) || hourNum < 1 || hourNum > 12) return '';
  if (!Number.isFinite(minuteNum) || minuteNum < 0 || minuteNum > 59) return '';

  let hour24 = hourNum % 12;
  if (safePeriod === 'PM') hour24 += 12;

  return `${String(hour24).padStart(2, '0')}:${String(minuteNum).padStart(2, '0')}`;
};

const TIME_HOURS_12 = Array.from({ length: 12 }, (_, i) => String(i + 1));
const TIME_MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, '0'));

function TimeAmPmInput({ value, onChange, label = '', disabled = false }) {
  const parts = getTime12Parts(value);

  const update = (field, nextValue) => {
    const nextParts = {
      ...parts,
      [field]: nextValue,
    };

    onChange(buildTimeFrom12(nextParts));
  };

  return (
    <div className="ff-time-ampm-control">
      {label ? <span>{label}</span> : null}

      <div className="ff-time-ampm-row">
        <select
          value={parts.hour}
          onChange={(e) => update('hour', e.target.value)}
          disabled={disabled}
        >
          <option value="">Hour</option>
          {TIME_HOURS_12.map((hour) => (
            <option key={hour} value={hour}>
              {hour}
            </option>
          ))}
        </select>

        <select
          value={parts.minute}
          onChange={(e) => update('minute', e.target.value)}
          disabled={disabled || !parts.hour}
        >
          {TIME_MINUTES.map((minute) => (
            <option key={minute} value={minute}>
              {minute}
            </option>
          ))}
        </select>

        <select
          value={parts.period}
          onChange={(e) => update('period', e.target.value)}
          disabled={disabled || !parts.hour}
        >
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </div>
    </div>
  );
}

const getTimingPreview = (settings = {}) => {
  const open = settings.shop_open_time || settings.opening_time;
  const close = settings.shop_close_time || settings.closing_time;

  if (!normalizeTimeValue(open) && !normalizeTimeValue(close)) {
    return 'Timing not set';
  }

  return `${formatTimeAmPm(open)} - ${formatTimeAmPm(close)}`;
};

const normalizeSettingsFromApi = (payload = {}) => {
  const data = payload?.settings || payload?.data || payload || {};

  const openTime = normalizeTimeValue(
    data.shop_open_time || data.shopOpenTime || data.opening_time || data.openingTime || ''
  );

  const closeTime = normalizeTimeValue(
    data.shop_close_time || data.shopCloseTime || data.closing_time || data.closingTime || ''
  );

  return {
    enable_dine_in: safeFlagToBool(data.enable_dine_in, true),
    enable_takeaway: safeFlagToBool(data.enable_takeaway ?? data.enable_pickup, true),
    enable_delivery: safeFlagToBool(data.enable_delivery ?? data.enable_home_delivery, false),
    allow_cod: safeFlagToBool(data.allow_cod, true),
    allow_online_payment: safeFlagToBool(data.allow_online_payment, true),

    preparation_time: Number(data.preparation_time ?? data.preparationTime ?? 20) || 20,
    packaging_fee: Number(data.packaging_fee ?? data.packagingFee ?? 0) || 0,
    delivery_fee: Number(data.delivery_fee ?? data.deliveryFee ?? 0) || 0,
    min_order_amount: Number(data.min_order_amount ?? data.minOrderAmount ?? 0) || 0,
    delivery_radius_km:
      data.delivery_radius_km === null || data.delivery_radius_km === undefined
        ? ''
        : data.delivery_radius_km,
    delivery_eta_min:
      data.delivery_eta_min === null || data.delivery_eta_min === undefined || data.delivery_eta_min === ''
        ? ''
        : data.delivery_eta_min,
    delivery_eta_max:
      data.delivery_eta_max === null || data.delivery_eta_max === undefined || data.delivery_eta_max === ''
        ? ''
        : data.delivery_eta_max,

    shop_open_time: openTime,
    shop_close_time: closeTime,
    opening_time: openTime,
    closing_time: closeTime,
  };
};

const buildSettingsPayload = (settings = {}) => {
  const openTime = normalizeTimeValue(settings.shop_open_time || settings.opening_time);
  const closeTime = normalizeTimeValue(settings.shop_close_time || settings.closing_time);

  return {
    vendorType: 'fastfood',
    businessType: 'fastfood',

    enable_dine_in: settings.enable_dine_in ? 1 : 0,
    enable_takeaway: settings.enable_takeaway ? 1 : 0,
    enable_pickup: settings.enable_takeaway ? 1 : 0,
    enable_delivery: settings.enable_delivery ? 1 : 0,
    enable_home_delivery: settings.enable_delivery ? 1 : 0,

    allow_cod: settings.allow_cod ? 1 : 0,
    allow_online_payment: settings.allow_online_payment ? 1 : 0,
    pickup_payment_required: 0,

    preparation_time: Number(settings.preparation_time || 0),
    packaging_fee: Math.max(0, Number(settings.packaging_fee || 0)),
    delivery_fee: Math.max(0, Number(settings.delivery_fee || 0)),
    min_order_amount: Math.max(0, Number(settings.min_order_amount || 0)),
    dine_in_min_amount: 0,
    pickup_min_amount: 0,
    delivery_min_amount: 0,
    delivery_radius_km:
      settings.delivery_radius_km === '' || settings.delivery_radius_km === null || settings.delivery_radius_km === undefined
        ? null
        : Math.max(0, Number(settings.delivery_radius_km || 0)),
    delivery_eta_min:
      settings.delivery_eta_min === '' || settings.delivery_eta_min === null || settings.delivery_eta_min === undefined
        ? null
        : Math.max(0, Number(settings.delivery_eta_min || 0)),
    delivery_eta_max:
      settings.delivery_eta_max === '' || settings.delivery_eta_max === null || settings.delivery_eta_max === undefined
        ? null
        : Math.max(0, Number(settings.delivery_eta_max || 0)),

    opening_time: openTime,
    closing_time: closeTime,
    shop_open_time: openTime,
    shop_close_time: closeTime,
  };
};

function FastFoodPage() {
  const token = localStorage.getItem('token') || '';
  const fileInputRef = useRef(null);
  const menuFileInputRef = useRef(null);
  const toastTimerRef = useRef(null);

  const [activeTab, setActiveTab] = useState('home');

  const [products, setProducts] = useState([]);
  const [customCategories, setCustomCategories] = useState([]);
  const [showNewCategoryInput, setShowNewCategoryInput] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [offers, setOffers] = useState([]);

  const [form, setForm] = useState(emptyProductForm);
  const [offerForm, setOfferForm] = useState(emptyOfferForm);
  const [settings, setSettings] = useState(defaultSettings);

  const [search, setSearch] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [availabilityFilter, setAvailabilityFilter] = useState('all');
  const [foodTypeFilter, setFoodTypeFilter] = useState('all');
  const [showTrendingOnly, setShowTrendingOnly] = useState(false);

  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  const [inlineEditingId, setInlineEditingId] = useState(null);
  const [inlineEditData, setInlineEditData] = useState({});
  const [inlineImagePreview, setInlineImagePreview] = useState('');
  const [savingInlineEdit, setSavingInlineEdit] = useState(false);

  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loadingOffers, setLoadingOffers] = useState(false);
  const [savingProduct, setSavingProduct] = useState(false);
  const [savingOffer, setSavingOffer] = useState(false);
  const [savingSettings, setSavingSettings] = useState(false);

  const [toast, setToast] = useState('');
  const [previewUrl, setPreviewUrl] = useState('');
  const [voiceSupported, setVoiceSupported] = useState(false);
  const [isListening, setIsListening] = useState(false);

  const [menuImportFile, setMenuImportFile] = useState(null);
  const [menuImportPreview, setMenuImportPreview] = useState('');
  const [menuImportedItems, setMenuImportedItems] = useState([]);
  const [readingMenu, setReadingMenu] = useState(false);
  const [savingMenuItems, setSavingMenuItems] = useState(false);

  // Quick Active / Inactive menu manager
  const [menuManageMode, setMenuManageMode] = useState(false);
  const [selectedMenuItemIds, setSelectedMenuItemIds] = useState([]);
  const [bulkAvailabilitySaving, setBulkAvailabilitySaving] = useState(false);
  const [quickDescriptions, setQuickDescriptions] = useState({});

  const showToast = (message) => {
    setToast(message);
    if (toastTimerRef.current) window.clearTimeout(toastTimerRef.current);
    toastTimerRef.current = window.setTimeout(() => setToast(''), 3500);
  };

  const authHeaders = useMemo(() => {
    return {
      Authorization: `Bearer ${token}`,
    };
  }, [token]);

  const toNumber = (value, fallback = 0) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : fallback;
  };

  const formatMoney = (value) => {
    const num = toNumber(value, 0);
    return `₹${num.toLocaleString('en-IN')}`;
  };

  const getImageUrl = (image) => {
    if (!image) return '';

    const value = Array.isArray(image) ? image[0] : String(image || '');

    if (
      value.startsWith('http://') ||
      value.startsWith('https://') ||
      value.startsWith('blob:')
    ) {
      return value;
    }

    return `${baseUrl}/${value.replace(/^\/+/, '')}`;
  };

  const getFirstImage = (image) => {
    if (!image) return '';

    if (Array.isArray(image)) {
      return image[0] || '';
    }

    return image;
  };

  const getProductPrice = (product) => toNumber(product?.price ?? product?.selling_price ?? 0, 0);

  const getProductCost = (product) => {
    const directCost = product?.cost_price ?? product?.cost_of_product ?? product?.purchase_price ?? product?.cost;
    const cost = toNumber(directCost, NaN);

    if (Number.isFinite(cost) && cost >= 0) return cost;

    return Math.round(getProductPrice(product) * 0.6);
  };

  const normalizeProduct = (product) => {
    const imageValue = Array.isArray(product.image)
      ? product.image[0]
      : product.image || product.image_url || '';

    const price = product.price ?? product.selling_price ?? 0;

    return {
      ...product,
      price,
      cost_price: product.cost_price ?? product.cost_of_product ?? product.purchase_price ?? '',
      category: product.category || 'Others',
      trend_item: Number(product.trend_item) === 1 ? 1 : 0,
      food_type: product.food_type || product.type || 'veg',
      availability: product.availability || product.stock_status || 'in_stock',
      image: imageValue,
      description: product.description || '',
    };
  };

  const getProductById = (productId) => {
    return products.find((product) => Number(product.id) === Number(productId)) || null;
  };

  const normalizeOfferFromApi = (offer = {}) => {
    let comboItems = offer.combo_items || offer.comboItems || [];
    let parsedExtra = {};

    try {
      if (typeof comboItems === 'string') comboItems = JSON.parse(comboItems);
    } catch {
      comboItems = [];
    }

    try {
      const extra = offer.extra_json || offer.offer_json || offer.meta_json || offer.metadata;
      if (typeof extra === 'string') parsedExtra = JSON.parse(extra);
      else if (extra && typeof extra === 'object') parsedExtra = extra;
    } catch {
      parsedExtra = {};
    }

    let progressiveSteps = offer.progressive_steps || parsedExtra.progressive_steps || [];
    try {
      if (typeof progressiveSteps === 'string') progressiveSteps = JSON.parse(progressiveSteps);
    } catch {
      progressiveSteps = [];
    }

    let daysActive = offer.days_active || parsedExtra.days_active || ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    try {
      if (typeof daysActive === 'string') daysActive = JSON.parse(daysActive);
    } catch {
      daysActive = String(daysActive || '').split(',').map((d) => d.trim()).filter(Boolean);
    }

    return {
      ...offer,
      ...parsedExtra,
      combo_items: Array.isArray(comboItems) ? comboItems : parsedExtra.combo_items || [],
      progressive_steps: Array.isArray(progressiveSteps) ? progressiveSteps : [],
      days_active: Array.isArray(daysActive) ? daysActive : [],
      offer_type: offer.offer_type || parsedExtra.offer_type || 'bill_discount',
      offer_name:
        offer.offer_name ||
        parsedExtra.offer_name ||
        offer.combo_name ||
        parsedExtra.combo_name ||
        offer.offer_text ||
        'Offer',
      is_active: safeFlagToBool(offer.is_active ?? parsedExtra.is_active ?? true, true),
    };
  };


  const getCoinRewardConfig = (offer = {}) => {
    const parsedOfferJson =
      typeof offer.offer_json === 'string'
        ? safeJsonParse(offer.offer_json, {})
        : offer.offer_json && typeof offer.offer_json === 'object'
          ? offer.offer_json
          : {};

    const parsedExtraJson =
      typeof offer.extra_json === 'string'
        ? safeJsonParse(offer.extra_json, {})
        : offer.extra_json && typeof offer.extra_json === 'object'
          ? offer.extra_json
          : {};

    const parsedMetaJson =
      typeof offer.meta_json === 'string'
        ? safeJsonParse(offer.meta_json, {})
        : offer.meta_json && typeof offer.meta_json === 'object'
          ? offer.meta_json
          : {};

    const source = {
      ...parsedMetaJson,
      ...parsedExtraJson,
      ...parsedOfferJson,
      ...offer,
    };

    const nestedCoins =
      source.coin_settings ||
      source.coins ||
      source.coin_config ||
      source.reward_config ||
      {};

    const preview = source.preview || {};

    const pickNumber = (...values) => {
      for (const value of values) {
        if (value === null || value === undefined || value === '') continue;

        const num = toNumber(value, NaN);

        if (Number.isFinite(num)) return num;
      }

      return 0;
    };

    const earnPercent = pickNumber(
      source.coin_earn_percent,
      nestedCoins.coin_earn_percent,
      preview.earnPercent,
      source.reward_value,
      source.discount_value
    );

    const minBill = pickNumber(
      source.coin_min_bill_amount,
      nestedCoins.coin_min_bill_amount,
      preview.minBill,
      source.min_bill_amount,
      source.min_purchasing_price
    );

    const minEarn = pickNumber(
      source.coin_min_earn,
      nestedCoins.coin_min_earn,
      preview.minEarn
    );

    const maxEarn = pickNumber(
      source.coin_max_earn_per_order,
      nestedCoins.coin_max_earn_per_order,
      preview.maxEarn
    );

    const coinValue = pickNumber(
      source.coin_value_rupees,
      nestedCoins.coin_value_rupees,
      preview.coinValue
    );

    const minRedeem = pickNumber(
      source.coin_min_redeem,
      nestedCoins.coin_min_redeem,
      preview.minRedeem
    );

    const maxRedeem = pickNumber(
      source.coin_max_redeem_per_order,
      nestedCoins.coin_max_redeem_per_order,
      preview.maxRedeem
    );

    const minOrderForRedeem = pickNumber(
      source.coin_min_order_for_redeem,
      nestedCoins.coin_min_order_for_redeem,
      preview.minOrderForRedeem
    );

    const expiryDays = pickNumber(
      source.coin_expiry_days,
      nestedCoins.coin_expiry_days,
      preview.expiryDays
    );

    return {
      coin_earn_percent: earnPercent,
      coin_min_bill_amount: minBill,
      coin_min_earn: minEarn,
      coin_max_earn_per_order: maxEarn,
      coin_value_rupees: coinValue,
      coin_min_redeem: minRedeem,
      coin_max_redeem_per_order: maxRedeem,
      coin_min_order_for_redeem: minOrderForRedeem,
      coin_expiry_days: expiryDays,
    };
  };

  const fetchProducts = async () => {
    if (!token) return;

    try {
      setLoadingProducts(true);

      const url = `${apiUrl}/products?userdb=true`;
      console.log('FastFood Products API:', url);

      const response = await axios.get(url, {
        headers: authHeaders,
      });

      const rawData = response.data;

      const data = Array.isArray(rawData)
        ? rawData
        : Array.isArray(rawData?.products)
          ? rawData.products
          : Array.isArray(rawData?.data)
            ? rawData.data
            : [];

      console.log('FastFood Products Response:', data);

      setProducts(data.map(normalizeProduct));
    } catch (err) {
      console.error('Fetch Products Error:', err);
      showToast(err.response?.data?.error || err.message || 'Products load nahi hua.');
    } finally {
      setLoadingProducts(false);
    }
  };

  const fetchOffers = async () => {
    if (!token) return;

    try {
      setLoadingOffers(true);

      const url = `${apiUrl}/offers?userdb=true`;
      console.log('FastFood Offers API:', url);

      const response = await axios.get(url, {
        headers: authHeaders,
      });

      const rawData = response.data;

      const data = Array.isArray(rawData)
        ? rawData
        : Array.isArray(rawData?.offers)
          ? rawData.offers
          : Array.isArray(rawData?.data)
            ? rawData.data
            : [];

      console.log('FastFood Offers Response:', data);

      setOffers(data.map(normalizeOfferFromApi));
    } catch (err) {
      console.error('Fetch Offers Error:', err);
      showToast(err.response?.data?.error || err.message || 'Offers load nahi hua.');
    } finally {
      setLoadingOffers(false);
    }
  };

  const fetchSettings = async () => {
    if (!token) return;

    try {
      const response = await axios.get(`${apiUrl}/order-settings?userdb=true`, {
        headers: authHeaders,
      });

      setSettings(normalizeSettingsFromApi(response.data));
    } catch (err) {
      console.error('Fetch Settings Error:', err);
      showToast(err.response?.data?.error || err.message || 'Settings load nahi hua.');
    }
  };

  useEffect(() => {
    if (!token) return;

    fetchProducts();
    fetchOffers();
    fetchSettings();
  }, [token]);

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    setVoiceSupported(Boolean(SpeechRecognition));
  }, []);

  useEffect(() => {
    if (form.image) {
      const url = URL.createObjectURL(form.image);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }

    if (form.existingImage) {
      setPreviewUrl(getImageUrl(form.existingImage));
    } else {
      setPreviewUrl('');
    }

    return undefined;
  }, [form.image, form.existingImage]);

  const offerStats = useMemo(() => {
    const activeOffers = offers.filter((offer) => safeFlagToBool(offer.is_active ?? true, true)).length;
    const pausedOffers = Math.max(offers.length - activeOffers, 0);
    const safeOffers = offers.filter((offer) => {
      const safety = getOfferSafetyFromOffer(offer);
      return safety.safe;
    }).length;
    const totalComboSets = offers.filter((offer) => String(offer.offer_type) === 'combo').length;

    return {
      activeOffers,
      pausedOffers,
      safeOffers,
      totalComboSets,
    };
  }, [offers, products]);

  const summary = useMemo(() => {
    const totalItems = products.length;
    const trendingItems = products.filter((p) => Number(p.trend_item) === 1).length;
    const activeOffers = offers.length;

    const unavailableItems = products.filter((p) => {
      const value = String(p.availability || '').toLowerCase();
      return value === 'out_of_stock' || value === 'unavailable' || value === 'off';
    }).length;

    return {
      totalItems,
      trendingItems,
      activeOffers,
      unavailableItems,
    };
  }, [products, offers]);

  const filteredProducts = useMemo(() => {
    let list = [...products];

    if (showTrendingOnly) {
      list = list.filter((p) => Number(p.trend_item) === 1);
    }

    if (categoryFilter !== 'all') {
      list = list.filter(
        (p) => String(p.category || '').toLowerCase() === categoryFilter.toLowerCase()
      );
    }

    if (availabilityFilter === 'unavailable') {
      list = list.filter((p) => {
        const value = String(p.availability || '').toLowerCase();
        return value === 'unavailable' || value === 'out_of_stock' || value === 'off';
      });
    } else if (availabilityFilter !== 'all') {
      list = list.filter(
        (p) => String(p.availability || '').toLowerCase() === availabilityFilter
      );
    }

    if (foodTypeFilter !== 'all') {
      list = list.filter(
        (p) => String(p.food_type || 'veg').toLowerCase() === foodTypeFilter
      );
    }

    const q = search.trim().toLowerCase();

    if (q) {
      list = list.filter((p) =>
        [
          p.name,
          p.category,
          p.price,
          p.description,
          p.food_type,
          p.availability,
        ].some((v) => String(v || '').toLowerCase().includes(q))
      );
    }

    return list;
  }, [
    products,
    search,
    categoryFilter,
    availabilityFilter,
    foodTypeFilter,
    showTrendingOnly,
  ]);

  const topItems = useMemo(() => {
    const trending = products.filter((p) => Number(p.trend_item) === 1);
    return (trending.length ? trending : products).slice(0, 5);
  }, [products]);

  const selectedComboItems = useMemo(() => {
    return (offerForm.combo_items || [])
      .filter((item) => item.productId)
      .map((item) => {
        const product = getProductById(item.productId);
        const qty = Math.max(1, toNumber(item.quantity, 1));
        const price = getProductPrice(product);
        const cost = getProductCost(product);

        const rawImage = product?.image || product?.image_url || product?.parentImage || '';

        return {
          productId: Number(item.productId),
          name: product?.name || 'Product',
          image: rawImage,
          image_url: rawImage,
          category: product?.category || 'Others',
          food_type: product?.food_type || 'veg',
          description: product?.description || '',
          quantity: qty,
          price,
          cost,
          lineTotal: price * qty,
          lineCost: cost * qty,
        };
      });
  }, [offerForm.combo_items, products]);

  const comboActualPrice = useMemo(() => {
    return selectedComboItems.reduce((sum, item) => sum + item.lineTotal, 0);
  }, [selectedComboItems]);

  const comboActualCost = useMemo(() => {
    return selectedComboItems.reduce((sum, item) => sum + item.lineCost, 0);
  }, [selectedComboItems]);

  const comboCustomerSave = useMemo(() => {
    return Math.max(0, comboActualPrice - toNumber(offerForm.combo_price, 0));
  }, [comboActualPrice, offerForm.combo_price]);

  const selectedAddonProduct = useMemo(() => {
    return offerForm.addon_product_id ? getProductById(offerForm.addon_product_id) : null;
  }, [offerForm.addon_product_id, products]);

  const selectedBuyProduct = useMemo(() => {
    return offerForm.buy_product_id ? getProductById(offerForm.buy_product_id) : null;
  }, [offerForm.buy_product_id, products]);

  const selectedGetProduct = useMemo(() => {
    return offerForm.get_product_id ? getProductById(offerForm.get_product_id) : null;
  }, [offerForm.get_product_id, products]);

  const addonOriginalPrice = useMemo(() => {
    return toNumber(
      offerForm.addon_original_price || selectedAddonProduct?.price || selectedAddonProduct?.selling_price,
      0
    );
  }, [offerForm.addon_original_price, selectedAddonProduct]);

  const addonCostPrice = useMemo(() => {
    return toNumber(
      offerForm.addon_cost_price || getProductCost(selectedAddonProduct),
      0
    );
  }, [offerForm.addon_cost_price, selectedAddonProduct]);

  const offerSafety = useMemo(() => {
    return calculateOfferSafety({
      offerType: offerForm.offer_type,
      comboPrice: toNumber(offerForm.combo_price, 0),
      comboCost: comboActualCost,
      addonSpecialPrice: toNumber(offerForm.addon_special_price, 0),
      addonCostPrice,
      minFinalMarginPercent: toNumber(offerForm.min_final_margin_percent, 15),
      minBillAmount: toNumber(offerForm.min_purchasing_price, 0),
    });
  }, [
    offerForm.offer_type,
    offerForm.combo_price,
    comboActualCost,
    offerForm.addon_special_price,
    addonCostPrice,
    offerForm.min_final_margin_percent,
    offerForm.min_purchasing_price,
  ]);


  const coinRewardPreview = useMemo(() => {
    const earnPercent = Math.max(0, toNumber(offerForm.coin_earn_percent, 0));
    const minBill = Math.max(0, toNumber(offerForm.coin_min_bill_amount, 0));
    const minEarn = Math.max(0, toNumber(offerForm.coin_min_earn, 0));
    const maxEarn = Math.max(0, toNumber(offerForm.coin_max_earn_per_order, 0));
    const coinValue = Math.max(0, toNumber(offerForm.coin_value_rupees, 0));
    const exampleBill = Math.max(minBill, 2000);
    const rawCoins = Math.floor((exampleBill * earnPercent) / 100);
    const cappedCoins = maxEarn > 0 ? Math.min(rawCoins, maxEarn) : rawCoins;
    const finalCoins = exampleBill >= minBill ? Math.max(minEarn, cappedCoins) : 0;
    const rewardValue = finalCoins * coinValue;

    return {
      earnPercent,
      minBill,
      minEarn,
      maxEarn,
      coinValue,
      exampleBill,
      finalCoins,
      rewardValue,
    };
  }, [
    offerForm.coin_earn_percent,
    offerForm.coin_min_bill_amount,
    offerForm.coin_min_earn,
    offerForm.coin_max_earn_per_order,
    offerForm.coin_value_rupees,
  ]);

  function calculateOfferSafety({
    offerType,
    comboPrice,
    comboCost,
    addonSpecialPrice,
    addonCostPrice,
    minFinalMarginPercent,
    minBillAmount,
  }) {
    const safeMargin = Math.max(0, Number(minFinalMarginPercent || 15));

    if (offerType === 'combo') {
      if (!comboPrice || !comboCost) {
        return {
          safe: false,
          label: 'Need Data',
          message: 'Combo item aur combo price add karein.',
          suggestion: 'Price/cost missing',
          marginAmount: 0,
          marginPercent: 0,
          minimumSafePrice: 0,
        };
      }

      const minimumSafePrice = Math.ceil(comboCost * (1 + safeMargin / 100));
      const marginAmount = comboPrice - comboCost;
      const marginPercent = comboPrice > 0 ? (marginAmount / comboPrice) * 100 : 0;

      return {
        safe: comboPrice >= minimumSafePrice,
        label: comboPrice >= minimumSafePrice ? 'Safe Offer' : 'Unsafe Offer',
        message:
          comboPrice >= minimumSafePrice
            ? 'Combo offer loss-proof lag raha hai.'
            : 'Combo price cost + safe margin se kam hai.',
        suggestion: `Minimum safe combo price ${formatMoney(minimumSafePrice)}`,
        marginAmount,
        marginPercent,
        minimumSafePrice,
      };
    }

    if (offerType === 'bill_unlock_addon') {
      if (!addonSpecialPrice || !addonCostPrice) {
        return {
          safe: false,
          label: 'Need Data',
          message: 'Add-on product, cost price aur special price add karein.',
          suggestion: 'Price/cost missing',
          marginAmount: 0,
          marginPercent: 0,
          minimumSafePrice: 0,
        };
      }

      const minimumSafePrice = Math.ceil(addonCostPrice * (1 + safeMargin / 100));
      const marginAmount = addonSpecialPrice - addonCostPrice;
      const marginPercent = addonSpecialPrice > 0 ? (marginAmount / addonSpecialPrice) * 100 : 0;

      return {
        safe: addonSpecialPrice >= minimumSafePrice,
        label: addonSpecialPrice >= minimumSafePrice ? 'Safe Offer' : 'Unsafe Offer',
        message:
          addonSpecialPrice >= minimumSafePrice
            ? 'Add-on offer loss-proof lag raha hai.'
            : 'Special price product cost + safe margin se kam hai.',
        suggestion: `Minimum safe price ${formatMoney(minimumSafePrice)}`,
        marginAmount,
        marginPercent,
        minimumSafePrice,
      };
    }

    if (offerType === 'bill_discount') {
      const discount = toNumber(offerForm.discount_value, 0);
      const maxDiscount = toNumber(offerForm.max_discount, 0);
      const finalDiscount = offerForm.discount_type === 'percent'
        ? Math.min((minBillAmount * discount) / 100, maxDiscount || Infinity)
        : discount;

      const maxAllowedDiscount = minBillAmount * 0.2;

      return {
        safe: finalDiscount <= maxAllowedDiscount,
        label: finalDiscount <= maxAllowedDiscount ? 'Safe Offer' : 'Review Needed',
        message:
          finalDiscount <= maxAllowedDiscount
            ? 'Discount minimum bill ke comparison me safe range me hai.'
            : 'Discount minimum bill ka 20% se zyada ho raha hai.',
        suggestion: `Recommended max discount ${formatMoney(maxAllowedDiscount)}`,
        marginAmount: Math.max(0, maxAllowedDiscount - finalDiscount),
        marginPercent: minBillAmount > 0 ? ((minBillAmount - finalDiscount) / minBillAmount) * 100 : 0,
        minimumSafePrice: 0,
      };
    }

    return {
      safe: true,
      label: 'Safe Offer',
      message: 'Offer ready hai.',
      suggestion: '',
      marginAmount: 0,
      marginPercent: 0,
      minimumSafePrice: 0,
    };
  }

  function getOfferSafetyFromOffer(offer) {
    const normalized = normalizeOfferFromApi(offer);

    if (normalized.offer_type === 'combo') {
      const items = Array.isArray(normalized.combo_items) ? normalized.combo_items : [];
      const cost = items.reduce((sum, item) => {
        const product = getProductById(item.productId || item.id);
        return sum + getProductCost(product) * Math.max(1, toNumber(item.quantity, 1));
      }, 0);

      return calculateOfferSafety({
        offerType: 'combo',
        comboPrice: toNumber(normalized.combo_price, 0),
        comboCost: cost,
        minFinalMarginPercent: toNumber(normalized.min_final_margin_percent, 15),
      });
    }

    if (normalized.offer_type === 'bill_unlock_addon') {
      const product = getProductById(normalized.addon_product_id);
      return calculateOfferSafety({
        offerType: 'bill_unlock_addon',
        addonSpecialPrice: toNumber(normalized.addon_special_price, 0),
        addonCostPrice: toNumber(normalized.addon_cost_price || getProductCost(product), 0),
        minFinalMarginPercent: toNumber(normalized.min_final_margin_percent, 15),
      });
    }

    if (['buy_x_get_y', 'time_slot_offer', 'progressive_unlock', 'coin_reward'].includes(normalized.offer_type)) {
      return {
        safe: true,
        label: 'Safe Offer',
        message: 'Backend final validation ke saath save hoga.',
        suggestion: '',
        marginAmount: 0,
        marginPercent: 0,
        minimumSafePrice: 0,
      };
    }

    return calculateOfferSafety({
      offerType: 'bill_discount',
      minBillAmount: toNumber(normalized.min_purchasing_price || normalized.min_bill_amount, 0),
    });
  }

  const resetProductForm = () => {
    setForm(emptyProductForm);
    setPreviewUrl('');
    setShowNewCategoryInput(false);
    setNewCategoryName('');

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const resetOfferForm = () => {
    setOfferForm(emptyOfferForm);
  };

  const setOfferType = (offerType) => {
    setOfferForm((prev) => ({
      ...emptyOfferForm,
      id: prev.id || null,
      offer_type: offerType,
      order_type: prev.order_type || 'individual',
      is_active: true,
    }));
  };

  const categoryOptions = useMemo(() => {
    const productCategories = products
      .map((product) => String(product.category || '').trim())
      .filter(Boolean);

    const allCategories = [
      ...CATEGORY_OPTIONS,
      ...productCategories,
      ...customCategories,
    ];

    const usedCategories = new Set();

    return allCategories.filter((category) => {
      const cleanCategory = String(category || '').trim();
      const normalizedCategory = cleanCategory.toLowerCase();

      if (!cleanCategory || usedCategories.has(normalizedCategory)) {
        return false;
      }

      usedCategories.add(normalizedCategory);
      return true;
    });
  }, [products, customCategories]);

  const handleCategorySelect = (e) => {
    const selectedValue = e.target.value;

    if (selectedValue === ADD_NEW_CATEGORY_VALUE) {
      setShowNewCategoryInput(true);
      return;
    }

    setForm((prev) => ({
      ...prev,
      category: selectedValue,
    }));

    setShowNewCategoryInput(false);
    setNewCategoryName('');
  };

  const handleAddNewCategory = () => {
    const cleanCategoryName = String(newCategoryName || '')
      .trim()
      .replace(/\s+/g, ' ');

    if (!cleanCategoryName) {
      showToast('New category ka name likhiye.');
      return;
    }

    const alreadyExistingCategory = categoryOptions.find(
      (category) => String(category).toLowerCase() === cleanCategoryName.toLowerCase()
    );

    const finalCategoryName = alreadyExistingCategory || cleanCategoryName;

    if (!alreadyExistingCategory) {
      setCustomCategories((prev) => [...prev, cleanCategoryName]);
    }

    setForm((prev) => ({
      ...prev,
      category: finalCategoryName,
    }));

    setNewCategoryName('');
    setShowNewCategoryInput(false);
    showToast(`Category "${finalCategoryName}" select ho gayi.`);
  };

  const handleCancelNewCategory = () => {
    setNewCategoryName('');
    setShowNewCategoryInput(false);
  };

  const handleProductChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'checkbox') {
      setForm((prev) => ({
        ...prev,
        [name]: checked,
      }));
      return;
    }

    if (type === 'file') {
      const file = files?.[0] || null;

      if (file && !file.type.startsWith('image/')) {
        showToast('Sirf image upload karein.');
        return;
      }

      setForm((prev) => ({
        ...prev,
        image: file,
      }));
      return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateProductForm = () => {
    if (!form.name.trim()) {
      showToast('Product name required hai.');
      return false;
    }

    if (!form.price) {
      showToast('Price required hai.');
      return false;
    }

    if (toNumber(form.price, -1) < 0) {
      showToast('Price valid nahi hai.');
      return false;
    }

    if (!form.category.trim()) {
      showToast('Category select karein.');
      return false;
    }


    return true;
  };

  const handleSubmitProduct = async (e) => {
    e.preventDefault();

    if (!validateProductForm()) return;

    try {
      setSavingProduct(true);

      const formData = new FormData();
      formData.append('name', form.name.trim());
      formData.append('price', form.price);
      formData.append('cost_price', form.cost_price || 0);
      formData.append('category', form.category);
      formData.append('trend_item', form.trend_item ? '1' : '0');
      formData.append('food_type', form.food_type || 'veg');
      formData.append('availability', form.availability || 'in_stock');
      formData.append('description', form.description || '');

      if (form.image) {
        formData.append('image', form.image);

        if (form.id) {
          formData.append('replace_image', '1');
        }
      }

      const config = {
        headers: {
          ...authHeaders,
          'Content-Type': 'multipart/form-data',
        },
      };

      const response = form.id
        ? await axios.put(`${apiUrl}/products/${form.id}?userdb=true`, formData, config)
        : await axios.post(`${apiUrl}/products?userdb=true`, formData, config);

      showToast(
        response.data?.message ||
          (form.id ? 'Product update ho gaya.' : 'Product add ho gaya.')
      );

      resetProductForm();
      await fetchProducts();
      setActiveTab('menu');
    } catch (err) {
      console.error('Add/Update Product Error:', err);
      showToast(err.response?.data?.error || `Product ${form.id ? 'update' : 'add'} failed.`);
    } finally {
      setSavingProduct(false);
    }
  };

  const startEditProduct = (product) => {
    setForm({
      id: product.id,
      name: product.name || '',
      price: product.price ?? '',
      cost_price: product.cost_price ?? '',
      category: product.category || '',
      image: null,
      existingImage: getFirstImage(product.image || product.image_url || ''),
      trend_item: Number(product.trend_item) === 1,
      food_type: product.food_type || 'veg',
      availability: product.availability || 'in_stock',
      description: product.description || '',
    });

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    setInlineEditingId(null);
    setInlineEditData({});
    setInlineImagePreview('');
    setActiveTab('products');

    window.setTimeout(() => {
      const el = document.querySelector('.ff-product-form-card');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const handleDeleteProduct = async (id) => {
    const ok = window.confirm('Ye product delete karna hai?');
    if (!ok) return;

    try {
      await axios.delete(`${apiUrl}/products/${id}?userdb=true`, {
        headers: authHeaders,
      });

      showToast('Product delete ho gaya.');
      setProducts((prev) => prev.filter((p) => Number(p.id) !== Number(id)));
      await fetchProducts();
    } catch (err) {
      console.error('Remove Product Error:', err);
      showToast(err.response?.data?.error || 'Product delete failed.');
    }
  };

  const handleQuickToggleTrending = async (product) => {
    try {
      const formData = new FormData();

      formData.append('name', product.name || '');
      formData.append('price', product.price || 0);
      formData.append('cost_price', product.cost_price || 0);
      formData.append('category', product.category || 'Others');
      formData.append('trend_item', Number(product.trend_item) === 1 ? '0' : '1');
      formData.append('food_type', product.food_type || 'veg');
      formData.append('availability', product.availability || 'in_stock');
      formData.append('description', product.description || '');

      await axios.put(`${apiUrl}/products/${product.id}?userdb=true`, formData, {
        headers: {
          ...authHeaders,
          'Content-Type': 'multipart/form-data',
        },
      });

      showToast('Trending status update ho gaya.');
      await fetchProducts();
    } catch (err) {
      console.error('Quick Toggle Trending Error:', err);
      showToast('Trending update failed.');
    }
  };

  const toggleDescription = (id) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const getShortDescription = (description, words = 3) => {
    const text = String(description || 'Fast food item').trim();
    const parts = text.split(/\s+/).filter(Boolean);

    if (parts.length <= words) return text;

    return `${parts.slice(0, words).join(' ')}...`;
  };

  const shouldShowReadMore = (description, words = 3) => {
    const text = String(description || '').trim();
    if (!text) return false;

    return text.split(/\s+/).filter(Boolean).length > words;
  };

  const getFoodBadge = (type) => {
    const value = String(type || 'veg').toLowerCase();

    if (value === 'non_veg') {
      return {
        label: '🔴 Non-Veg',
        className: 'nonveg',
      };
    }

    if (value === 'egg') {
      return {
        label: '🟡 Egg',
        className: 'egg',
      };
    }

    return {
      label: '🟢 Veg',
      className: 'veg',
    };
  };

  const startInlineEdit = (product) => {
    setInlineEditingId(product.id);
    setInlineImagePreview(getImageUrl(product.image));

    setInlineEditData({
      id: product.id,
      name: product.name || '',
      price: product.price || '',
      cost_price: product.cost_price || '',
      category: product.category || 'Others',
      availability: product.availability || 'in_stock',
      food_type: product.food_type || 'veg',
      description: product.description || '',
      trend_item: Number(product.trend_item) === 1,
      image: null,
      existingImage: getFirstImage(product.image || product.image_url || ''),
    });
  };

  const cancelInlineEdit = () => {
    setInlineEditingId(null);
    setInlineEditData({});
    setInlineImagePreview('');
  };

  const handleInlineChange = (field, value) => {
    setInlineEditData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleInlineImageChange = (file) => {
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      showToast('Sirf image upload karein.');
      return;
    }

    const url = URL.createObjectURL(file);

    setInlineImagePreview(url);

    setInlineEditData((prev) => ({
      ...prev,
      image: file,
    }));
  };

  const saveInlineEdit = async () => {
    if (!inlineEditData.id) return;

    if (!String(inlineEditData.name || '').trim()) {
      showToast('Product name required hai.');
      return;
    }

    if (!inlineEditData.price) {
      showToast('Price required hai.');
      return;
    }

    try {
      setSavingInlineEdit(true);

      const formData = new FormData();

      formData.append('name', String(inlineEditData.name || '').trim());
      formData.append('price', inlineEditData.price || 0);
      formData.append('cost_price', inlineEditData.cost_price || 0);
      formData.append('category', inlineEditData.category || 'Others');
      formData.append('availability', inlineEditData.availability || 'in_stock');
      formData.append('food_type', inlineEditData.food_type || 'veg');
      formData.append('description', inlineEditData.description || '');
      formData.append('trend_item', inlineEditData.trend_item ? '1' : '0');

      if (inlineEditData.image) {
        formData.append('image', inlineEditData.image);
        formData.append('replace_image', '1');
      }

      await axios.put(`${apiUrl}/products/${inlineEditData.id}?userdb=true`, formData, {
        headers: {
          ...authHeaders,
          'Content-Type': 'multipart/form-data',
        },
      });

      showToast('Product update ho gaya.');

      setInlineEditingId(null);
      setInlineEditData({});
      setInlineImagePreview('');

      await fetchProducts();
    } catch (err) {
      console.error('Inline Edit Error:', err);
      showToast(err.response?.data?.error || 'Inline update failed.');
    } finally {
      setSavingInlineEdit(false);
    }
  };


  const getEmptyMenuImportItem = () => ({
    name: '',
    price: '',
    cost_price: '',
    category: 'Others',
    food_type: 'veg',
    availability: 'in_stock',
    trend_item: false,
    description: '',
  });

  const normalizeMenuImportItem = (item = {}) => {
    const cleanName = String(item.name || item.product_name || '').trim();
    const cleanCategory = String(item.category || 'Others').trim() || 'Others';
    const priceValue = item.price ?? item.selling_price ?? '';
    const costValue = item.cost_price ?? item.cost ?? '';
    const foodType = String(item.food_type || item.type || 'veg').toLowerCase();
    const safeFoodType = ['veg', 'non_veg', 'egg'].includes(foodType) ? foodType : 'veg';
    const availability = String(item.availability || 'in_stock').toLowerCase();
    const safeAvailability = ['in_stock', 'out_of_stock', 'unavailable'].includes(availability)
      ? availability
      : 'in_stock';

    return {
      name: cleanName,
      price: priceValue === null || priceValue === undefined ? '' : String(priceValue).replace(/[^0-9.]/g, ''),
      cost_price: costValue === null || costValue === undefined ? '' : String(costValue).replace(/[^0-9.]/g, ''),
      category: cleanCategory,
      food_type: safeFoodType,
      availability: safeAvailability,
      trend_item: Boolean(item.trend_item),
      description: String(item.description || '').trim(),
    };
  };

  const handleMenuImportFileChange = (e) => {
    const file = e.target.files?.[0] || null;

    if (!file) return;

    if (!file.type.startsWith('image/')) {
      showToast('Sirf menu image upload karein.');
      return;
    }

    const preview = URL.createObjectURL(file);
    setMenuImportFile(file);
    setMenuImportPreview(preview);
    setMenuImportedItems([]);
  };

  const clearMenuImport = () => {
    if (menuImportPreview && menuImportPreview.startsWith('blob:')) {
      URL.revokeObjectURL(menuImportPreview);
    }

    setMenuImportFile(null);
    setMenuImportPreview('');
    setMenuImportedItems([]);

    if (menuFileInputRef.current) {
      menuFileInputRef.current.value = '';
    }
  };

  const openMenuUploadPicker = () => {
    setActiveTab('menu');

    window.setTimeout(() => {
      if (menuFileInputRef.current) {
        menuFileInputRef.current.click();
      } else {
        showToast('Menu upload input ready nahi hua. Page refresh karke try karein.');
      }
    }, 80);
  };

  const refreshFastFoodData = async () => {
    try {
      await Promise.all([fetchProducts(), fetchOffers(), fetchSettings()]);
      showToast('Data refresh ho gaya.');
    } catch (err) {
      console.error('Refresh Error:', err);
      showToast('Refresh failed.');
    }
  };

  const scanMenuWithAI = async () => {
    if (!menuImportFile) {
      showToast('Pehle menu photo upload karein.');
      return;
    }

    try {
      setReadingMenu(true);

      const formData = new FormData();
      formData.append('menu_image', menuImportFile);

      const response = await axios.post(`${apiUrl}/products/import-menu-scan?userdb=true`, formData, {
        headers: {
          ...authHeaders,
          'Content-Type': 'multipart/form-data',
        },
      });

      const rawItems = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data?.items)
          ? response.data.items
          : Array.isArray(response.data?.products)
            ? response.data.products
            : [];

      const nextItems = rawItems
        .map(normalizeMenuImportItem)
        .filter((item) => item.name && item.price);

      if (!nextItems.length) {
        showToast('Menu se item read nahi hua. Clear photo upload karein.');
        return;
      }

      const newCategories = nextItems
        .map((item) => item.category)
        .filter(Boolean)
        .filter((category) => !categoryOptions.some((c) => c.toLowerCase() === category.toLowerCase()));

      if (newCategories.length) {
        setCustomCategories((prev) => [...prev, ...new Set(newCategories)]);
      }

      setMenuImportedItems(nextItems);
      showToast(`${nextItems.length} menu items ready.`);
    } catch (err) {
      console.error('AI Menu Scan Error:', err);
      showToast(err.response?.data?.error || 'Menu scan failed. Backend AI route check karein.');
    } finally {
      setReadingMenu(false);
    }
  };

  const updateMenuImportItem = (index, field, value) => {
    setMenuImportedItems((prev) => {
      const next = [...prev];
      next[index] = {
        ...next[index],
        [field]: value,
      };
      return next;
    });
  };

  const removeMenuImportItem = (index) => {
    setMenuImportedItems((prev) => prev.filter((_, i) => i !== index));
  };

  const addBlankMenuImportItem = () => {
    setMenuImportedItems((prev) => [...prev, getEmptyMenuImportItem()]);
  };

  const saveMenuImportedItems = async () => {
    const validItems = menuImportedItems
      .map(normalizeMenuImportItem)
      .filter((item) => item.name && item.price && item.category);

    if (!validItems.length) {
      showToast('Save karne ke liye valid item nahi hai.');
      return;
    }

    try {
      setSavingMenuItems(true);

      for (const item of validItems) {
        const formData = new FormData();
        formData.append('name', item.name);
        formData.append('price', item.price);
        formData.append('cost_price', item.cost_price || 0);
        formData.append('category', item.category || 'Others');
        formData.append('trend_item', item.trend_item ? '1' : '0');
        formData.append('food_type', item.food_type || 'veg');
        formData.append('availability', item.availability || 'in_stock');
        formData.append('description', item.description || '');

        await axios.post(`${apiUrl}/products?userdb=true`, formData, {
          headers: {
            ...authHeaders,
            'Content-Type': 'multipart/form-data',
          },
        });
      }

      showToast(`${validItems.length} items menu me add ho gaye.`);
      clearMenuImport();
      await fetchProducts();
      setActiveTab('menu');
    } catch (err) {
      console.error('Save AI Menu Items Error:', err);
      showToast(err.response?.data?.error || 'Menu items save failed.');
    } finally {
      setSavingMenuItems(false);
    }
  };

  const renderAiMenuImportPanel = () => (
    <div className="ff-card ff-ai-menu-import-card">
      <div className="ff-ai-menu-import-head">
        <div>
          <h3>📷 AI Menu Import</h3>
          <p>Menu photo upload karein. AI item name, category aur price list bana dega. Image default rahegi, baad me edit kar sakte hain.</p>
        </div>

        <div className="ff-ai-menu-import-actions">
          <button type="button" className="ff-primary-btn" onClick={openMenuUploadPicker}>
            Upload Menu
          </button>

        </div>
      </div>

      {menuImportPreview ? (
        <div className="ff-ai-menu-preview-box">
          <img src={menuImportPreview} alt="Uploaded Menu" />

          <div>
            <strong>{menuImportFile?.name || 'Menu image selected'}</strong>
            <small>Photo clear rahega to item aur price zyada accurate aayega.</small>

            <div className="ff-ai-menu-preview-actions">
              <button type="button" className="ff-primary-btn" onClick={scanMenuWithAI} disabled={readingMenu}>
                AI Se List Banao
              </button>

              <button type="button" className="ff-light-btn" onClick={clearMenuImport} disabled={readingMenu || savingMenuItems}>
                Clear
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {menuImportedItems.length ? (
        <div className="ff-ai-menu-review-box">
          <div className="ff-ai-menu-review-head">
            <div>
              <h3>Review Menu Items</h3>
              <p>Save karne se pehle name, category aur price check kar lein.</p>
            </div>

            <button type="button" className="ff-light-btn" onClick={addBlankMenuImportItem} disabled={savingMenuItems}>
              + Add Row
            </button>
          </div>

          <div className="ff-ai-menu-table">
            <div className="ff-ai-menu-row ff-ai-menu-head-row">
              <span>No</span>
              <span>Product</span>
              <span>Category</span>
              <span>Price</span>
              <span>Food</span>
              <span>Default Image</span>
              <span>Action</span>
            </div>

            {menuImportedItems.map((item, index) => (
              <div className="ff-ai-menu-row" key={`${item.name}-${index}`}>
                <span className="ff-ai-menu-sr">{index + 1}</span>

                <input
                  value={item.name}
                  onChange={(e) => updateMenuImportItem(index, 'name', e.target.value)}
                  placeholder="Product name"
                />

                <input
                  value={item.category}
                  onChange={(e) => updateMenuImportItem(index, 'category', e.target.value)}
                  placeholder="Category"
                />

                <input
                  type="number"
                  value={item.price}
                  onChange={(e) => updateMenuImportItem(index, 'price', e.target.value)}
                  placeholder="Price"
                />

                <select
                  value={item.food_type}
                  onChange={(e) => updateMenuImportItem(index, 'food_type', e.target.value)}
                >
                  <option value="veg">Veg</option>
                  <option value="non_veg">Non-Veg</option>
                  <option value="egg">Egg</option>
                </select>

                <span className="ff-ai-default-img-pill">Default</span>

                <button type="button" className="ff-text-btn" onClick={() => removeMenuImportItem(index)} disabled={savingMenuItems}>
                  Remove
                </button>
              </div>
            ))}
          </div>

          <div className="ff-ai-menu-save-bar">
            <span>{menuImportedItems.length} items ready</span>

            <button type="button" className="ff-primary-btn" onClick={saveMenuImportedItems} disabled={savingMenuItems}>
              Save All Items
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );

  const handleVoiceInput = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      showToast('Voice input is browser me support nahi hai.');
      return;
    }

    const recognition = new SpeechRecognition();

    recognition.lang = 'en-IN';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    setIsListening(true);

    recognition.onresult = (event) => {
      const transcript = event.results?.[0]?.[0]?.transcript || '';

      setForm((prev) => ({
        ...prev,
        name: transcript,
      }));
    };

    recognition.onerror = () => {
      setIsListening(false);
      showToast('Voice input failed.');
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.start();
  };

  const updateComboItem = (index, field, value) => {
    setOfferForm((prev) => {
      const items = [...(prev.combo_items || [])];
      items[index] = {
        ...items[index],
        [field]: field === 'quantity' ? Math.max(1, Number(value || 1)) : value,
      };

      return {
        ...prev,
        combo_items: items,
      };
    });
  };

  const addComboItem = () => {
    setOfferForm((prev) => ({
      ...prev,
      combo_items: [...(prev.combo_items || []), { ...emptyComboItem }],
    }));
  };

  const removeComboItem = (index) => {
    setOfferForm((prev) => ({
      ...prev,
      combo_items: (prev.combo_items || []).filter((_, i) => i !== index),
    }));
  };

  const handleOfferItemChange = (index, field, value) => {
    setOfferForm((prev) => {
      const nextItems = [...prev.offerItems];

      nextItems[index] = {
        ...nextItems[index],
        [field]: value,
      };

      return {
        ...prev,
        offerItems: nextItems,
      };
    });
  };

  const addOfferItem = () => {
    setOfferForm((prev) => ({
      ...prev,
      offerItems: [...prev.offerItems, { product: '', value: '' }],
    }));
  };

  const removeOfferItem = (index) => {
    setOfferForm((prev) => ({
      ...prev,
      offerItems: prev.offerItems.filter((_, i) => i !== index),
    }));
  };

  const calculateOffer = () => {
    const type = offerForm.offer_type;

    if (type === 'coin_reward') {
      const earnPercent = toNumber(offerForm.coin_earn_percent, 0);
      const minBill = toNumber(offerForm.coin_min_bill_amount, 0);
      const maxEarn = toNumber(offerForm.coin_max_earn_per_order, 0);
      const coinValue = toNumber(offerForm.coin_value_rupees, 0);

      if (!offerForm.offer_name.trim()) return 'Coins reward name required';
      if (earnPercent <= 0) return 'Coins earn percentage required';
      if (coinValue <= 0) return 'Coin value required';

      return `${earnPercent}% Shop Coins on bill ${formatMoney(minBill)}+${maxEarn > 0 ? `, max ${maxEarn} coins/order` : ''} • 1 coin = ${formatMoney(coinValue)}`;
    }

    if (type === 'combo') {
      const validItems = selectedComboItems.filter((item) => item.productId && item.quantity > 0);
      const comboPrice = toNumber(offerForm.combo_price, 0);

      if (!offerForm.offer_name.trim()) return 'Combo name required';
      if (validItems.length < 2) return 'Minimum 2 combo items required';
      if (comboPrice <= 0) return 'Combo price required';

      return `${offerForm.offer_name.trim()} @ ${formatMoney(comboPrice)} (Save ${formatMoney(comboCustomerSave)})`;
    }

    if (type === 'bill_unlock_addon') {
      const minBill = toNumber(offerForm.min_purchasing_price, 0);
      const specialPrice = toNumber(offerForm.addon_special_price, 0);
      const product = selectedAddonProduct;

      if (!offerForm.offer_name.trim()) return 'Offer name required';
      if (minBill <= 0) return 'Minimum bill required';
      if (!product) return 'Add-on product required';
      if (specialPrice <= 0) return 'Special price required';

      return `${product.name} only ${formatMoney(specialPrice)} on bill ${formatMoney(minBill)}+`;
    }

    if (type === 'bill_discount') {
      const minBill = toNumber(offerForm.min_purchasing_price, 0);
      const discountValue = toNumber(offerForm.discount_value, 0);

      if (!offerForm.offer_name.trim()) return 'Offer name required';
      if (minBill <= 0) return 'Minimum bill required';
      if (discountValue <= 0) return 'Discount required';

      return offerForm.discount_type === 'percent'
        ? `${discountValue}% off on bill ${formatMoney(minBill)}+`
        : `${formatMoney(discountValue)} off on bill ${formatMoney(minBill)}+`;
    }

    if (type === 'buy_x_get_y') {
      const buyQty = Math.max(1, toNumber(offerForm.buy_quantity, 1));
      const getQty = Math.max(1, toNumber(offerForm.get_quantity, 1));
      const rewardValue = toNumber(offerForm.reward_value, 0);

      if (!offerForm.offer_name.trim()) return 'Offer name required';
      if (!selectedBuyProduct) return 'Buy product required';
      if (!selectedGetProduct) return 'Reward product required';

      const rewardText = offerForm.reward_type === 'free'
        ? 'Free'
        : offerForm.reward_type === 'percent_discount'
          ? `${rewardValue}% OFF`
          : `${formatMoney(rewardValue)}`;

      return `Buy ${buyQty} ${selectedBuyProduct.name}, get ${getQty} ${selectedGetProduct.name} ${rewardText}`;
    }

    if (type === 'time_slot_offer') {
      if (!offerForm.offer_name.trim()) return 'Offer name required';
      if (toNumber(offerForm.min_purchasing_price, 0) <= 0) return 'Minimum bill amount required';
      if (!offerForm.start_time || !offerForm.end_time) return 'Start and end time required';
      if (toNumber(offerForm.discount_value, 0) <= 0 && toNumber(offerForm.addon_special_price, 0) <= 0) {
        return 'Discount or special price required';
      }

      const valueText = toNumber(offerForm.addon_special_price, 0) > 0
        ? `Special price ${formatMoney(offerForm.addon_special_price)}`
        : offerForm.discount_type === 'percent'
          ? `${offerForm.discount_value}% OFF`
          : `${formatMoney(offerForm.discount_value)} OFF`;

      return `${offerForm.offer_name.trim()} • Bill ${formatMoney(offerForm.min_purchasing_price)}+ • ${formatTimeAmPm(offerForm.start_time)} - ${formatTimeAmPm(offerForm.end_time)} • ${valueText}`;
    }

    if (type === 'progressive_unlock') {
      const validSteps = (offerForm.progressive_steps || []).filter((step) => {
        return toNumber(step.min_bill_amount, 0) > 0 && String(step.reward_label || '').trim();
      });

      if (!offerForm.offer_name.trim()) return 'Offer name required';
      if (validSteps.length < 2) return 'Minimum 2 unlock steps required';

      return `${offerForm.offer_name.trim()} • ${validSteps.length} reward steps`;
    }

    const minPrice = parseFloat(offerForm.min_purchasing_price);
    const maxPrice = parseFloat(offerForm.max_purchasing_price);

    if (
      isNaN(minPrice) ||
      isNaN(maxPrice) ||
      minPrice >= maxPrice ||
      minPrice < 0 ||
      maxPrice < 0
    ) {
      return 'Invalid Range';
    }

    const validOfferItems = offerForm.offerItems.filter((item) => {
      const value = parseFloat(item.value);
      return item.product.trim() && !isNaN(value) && value >= 0;
    });

    if (validOfferItems.length === 0) {
      return 'No Offer';
    }

    return validOfferItems
      .map((item) => {
        const value = parseFloat(item.value);
        const formattedValue = value % 1 === 0 ? value.toString() : value.toFixed(2);
        return `${formattedValue}₹ ${item.product.trim()}`;
      })
      .join(', ');
  };

  const formatOfferForDisplay = (offerText) => {
    if (!offerText) return '-';

    return String(offerText)
      .split(', ')
      .map((item) => {
        const [value, product] = item.split('₹ ');
        const parsedValue = parseFloat(value);

        const formattedValue =
          Number.isFinite(parsedValue) && parsedValue % 1 === 0
            ? parsedValue.toString()
            : value;

        return `${formattedValue}₹ ${product || ''}`.trim();
      })
      .join(', ');
  };

  const validateOfferForm = () => {
    const type = offerForm.offer_type;

    if (type === 'coin_reward') {
      if (!offerForm.offer_name.trim()) {
        showToast('Coins reward offer name required hai.');
        return false;
      }

      if (toNumber(offerForm.coin_earn_percent, 0) <= 0 || toNumber(offerForm.coin_earn_percent, 0) > 100) {
        showToast('Coins percentage 0 se zyada aur 100 se kam/equal hona chahiye.');
        return false;
      }

      if (
        offerForm.coin_min_bill_amount === '' ||
        toNumber(offerForm.coin_min_bill_amount, 0) <= 0
      ) {
        showToast('Coins ke liye minimum bill amount required hai.');
        return false;
      }

      if (
        offerForm.coin_min_earn === '' ||
        toNumber(offerForm.coin_min_earn, 0) <= 0
      ) {
        showToast('Minimum earn coins required hai.');
        return false;
      }

      if (toNumber(offerForm.coin_max_earn_per_order, 0) <= 0) {
        showToast('Maximum earn coins per order required hai.');
        return false;
      }

      if (toNumber(offerForm.coin_value_rupees, 0) <= 0) {
        showToast('1 coin ki rupee value required hai.');
        return false;
      }

      if (toNumber(offerForm.coin_min_redeem, 0) <= 0) {
        showToast('Minimum redeem coins required hai.');
        return false;
      }

      if (toNumber(offerForm.coin_max_redeem_per_order, 0) <= 0) {
        showToast('Maximum redeem coins per order required hai.');
        return false;
      }

      if (toNumber(offerForm.coin_max_redeem_per_order, 0) < toNumber(offerForm.coin_min_redeem, 0)) {
        showToast('Maximum redeem coins minimum redeem se kam nahi ho sakta.');
        return false;
      }

      if (
        offerForm.coin_min_order_for_redeem === '' ||
        toNumber(offerForm.coin_min_order_for_redeem, 0) <= 0
      ) {
        showToast('Redeem ke liye minimum order amount required hai.');
        return false;
      }

      if (toNumber(offerForm.coin_expiry_days, 0) <= 0) {
        showToast('Coin expiry days required hai.');
        return false;
      }

      return true;
    }

    if (type === 'combo') {
      if (!offerForm.offer_name.trim()) {
        showToast('Combo name required hai.');
        return false;
      }

      if (selectedComboItems.length < 2) {
        showToast('Combo me minimum 2 products add karein.');
        return false;
      }

      if (toNumber(offerForm.combo_price, 0) <= 0) {
        showToast('Combo price required hai.');
        return false;
      }

      if (!offerSafety.safe) {
        showToast(`Unsafe combo. ${offerSafety.suggestion}`);
        return false;
      }

      return true;
    }

    if (type === 'bill_unlock_addon') {
      if (!offerForm.offer_name.trim()) {
        showToast('Offer name required hai.');
        return false;
      }

      if (toNumber(offerForm.min_purchasing_price, 0) <= 0) {
        showToast('Minimum bill amount required hai.');
        return false;
      }

      if (!offerForm.addon_product_id) {
        showToast('Add-on product select karein.');
        return false;
      }

      if (toNumber(offerForm.addon_special_price, 0) <= 0) {
        showToast('Special offer price required hai.');
        return false;
      }

      if (!offerSafety.safe) {
        showToast(`Unsafe add-on offer. ${offerSafety.suggestion}`);
        return false;
      }

      return true;
    }

    if (type === 'bill_discount') {
      if (!offerForm.offer_name.trim()) {
        showToast('Offer name required hai.');
        return false;
      }

      if (toNumber(offerForm.min_purchasing_price, 0) <= 0) {
        showToast('Minimum bill amount required hai.');
        return false;
      }

      if (toNumber(offerForm.discount_value, 0) <= 0) {
        showToast('Discount value required hai.');
        return false;
      }

      return true;
    }

    if (type === 'buy_x_get_y') {
      if (!offerForm.offer_name.trim()) {
        showToast('Offer name required hai.');
        return false;
      }
      if (!offerForm.buy_product_id || toNumber(offerForm.buy_quantity, 0) <= 0) {
        showToast('Buy product aur quantity required hai.');
        return false;
      }
      if (!offerForm.get_product_id || toNumber(offerForm.get_quantity, 0) <= 0) {
        showToast('Reward product aur quantity required hai.');
        return false;
      }
      if (offerForm.reward_type !== 'free' && toNumber(offerForm.reward_value, 0) <= 0) {
        showToast('Reward value required hai.');
        return false;
      }
      return true;
    }

    if (type === 'time_slot_offer') {
      if (!offerForm.offer_name.trim()) {
        showToast('Offer name required hai.');
        return false;
      }
      if (toNumber(offerForm.min_purchasing_price, 0) <= 0) {
        showToast('Minimum bill amount required hai.');
        return false;
      }
      if (!offerForm.start_time || !offerForm.end_time) {
        showToast('Start time aur end time required hai.');
        return false;
      }
      if (!offerForm.days_active || offerForm.days_active.length === 0) {
        showToast('Kam se kam ek day select karein.');
        return false;
      }
      if (toNumber(offerForm.discount_value, 0) <= 0 && toNumber(offerForm.addon_special_price, 0) <= 0) {
        showToast('Discount ya special price required hai.');
        return false;
      }
      return true;
    }

    if (type === 'progressive_unlock') {
      const validSteps = (offerForm.progressive_steps || []).filter((step) => {
        return toNumber(step.min_bill_amount, 0) > 0 && String(step.reward_label || '').trim();
      });
      if (!offerForm.offer_name.trim()) {
        showToast('Offer name required hai.');
        return false;
      }
      if (validSteps.length < 2) {
        showToast('Progressive unlock me minimum 2 valid steps required hain.');
        return false;
      }
      return true;
    }

    return true;
  };

  const buildOfferPayload = () => {
    const type = offerForm.offer_type;
    const offerText = calculateOffer();
    const minPrice = toNumber(offerForm.min_purchasing_price, 0);
    const maxPrice = toNumber(offerForm.max_purchasing_price || 999999, 999999);

    const basePayload = {
      offer_type: type,
      offer_name: offerForm.offer_name.trim(),
      order_type: offerForm.order_type || 'individual',
      min_purchasing_price: minPrice,
      max_purchasing_price: maxPrice,
      min_bill_amount: minPrice,
      group_size:
        offerForm.order_type === 'group'
          ? parseInt(offerForm.group_size, 10) || null
          : null,
      family_size:
        offerForm.order_type === 'family'
          ? parseInt(offerForm.family_size, 10) || null
          : null,
      offer_text: offerText,
      is_active: offerForm.is_active ? 1 : 0,
      safety_mode: offerForm.safety_mode || 'balanced',
      min_final_margin_percent: toNumber(offerForm.min_final_margin_percent, 15),
    };

    if (type === 'coin_reward') {
      const coinPayload = {
        offer_type: type,
        offer_name: offerForm.offer_name.trim(),
        coin_earn_percent: toNumber(offerForm.coin_earn_percent, 0),
        coin_min_bill_amount: toNumber(offerForm.coin_min_bill_amount, 0),
        coin_min_earn: toNumber(offerForm.coin_min_earn, 0),
        coin_max_earn_per_order: toNumber(offerForm.coin_max_earn_per_order, 0),
        coin_value_rupees: toNumber(offerForm.coin_value_rupees, 0),
        coin_min_redeem: toNumber(offerForm.coin_min_redeem, 0),
        coin_max_redeem_per_order: toNumber(offerForm.coin_max_redeem_per_order, 0),
        coin_min_order_for_redeem: toNumber(offerForm.coin_min_order_for_redeem, 0),
        coin_expiry_days: toNumber(offerForm.coin_expiry_days, 0),
        reward_type: 'percentage_coins',
      };

      return {
        ...basePayload,
        min_purchasing_price: coinPayload.coin_min_bill_amount,
        min_bill_amount: coinPayload.coin_min_bill_amount,
        max_purchasing_price: 999999,
        discount_type: 'coins',
        discount_value: coinPayload.coin_earn_percent,
        reward_type: 'percentage_coins',
        ...coinPayload,
        offer_text: calculateOffer(),
        offer_json: {
          ...coinPayload,
          preview: coinRewardPreview,
        },
      };
    }

    if (type === 'combo') {
      return {
        ...basePayload,
        combo_name: offerForm.offer_name.trim(),
        combo_items: selectedComboItems.map((item) => ({
          productId: item.productId,
          id: item.productId,
          name: item.name,
          image: item.image || '',
          image_url: item.image_url || item.image || '',
          category: item.category || 'Others',
          food_type: item.food_type || 'veg',
          description: item.description || '',
          quantity: item.quantity,
          price: item.price,
          cost: item.cost,
        })),
        combo_price: toNumber(offerForm.combo_price, 0),
        actual_price: comboActualPrice,
        customer_save: comboCustomerSave,
        offer_json: {
          offer_type: type,
          offer_name: offerForm.offer_name.trim(),
          combo_items: selectedComboItems,
          combo_price: toNumber(offerForm.combo_price, 0),
          actual_price: comboActualPrice,
          customer_save: comboCustomerSave,
          safety: offerSafety,
        },
      };
    }

    if (type === 'bill_unlock_addon') {
      const product = selectedAddonProduct;

      return {
        ...basePayload,
        addon_product_id: Number(offerForm.addon_product_id),
        addon_product_name: product?.name || '',
        addon_original_price: addonOriginalPrice,
        addon_cost_price: addonCostPrice,
        addon_special_price: toNumber(offerForm.addon_special_price, 0),
        limit_per_order: Math.max(1, Number(offerForm.limit_per_order || 1)),
        offer_json: {
          offer_type: type,
          offer_name: offerForm.offer_name.trim(),
          addon_product_id: Number(offerForm.addon_product_id),
          addon_product_name: product?.name || '',
          addon_original_price: addonOriginalPrice,
          addon_cost_price: addonCostPrice,
          addon_special_price: toNumber(offerForm.addon_special_price, 0),
          limit_per_order: Math.max(1, Number(offerForm.limit_per_order || 1)),
          safety: offerSafety,
        },
      };
    }

    if (type === 'bill_discount') {
      return {
        ...basePayload,
        discount_type: offerForm.discount_type,
        discount_value: toNumber(offerForm.discount_value, 0),
        max_discount: toNumber(offerForm.max_discount, 0),
        offer_json: {
          offer_type: type,
          offer_name: offerForm.offer_name.trim(),
          discount_type: offerForm.discount_type,
          discount_value: toNumber(offerForm.discount_value, 0),
          max_discount: toNumber(offerForm.max_discount, 0),
          safety: offerSafety,
        },
      };
    }

    if (type === 'buy_x_get_y') {
      return {
        ...basePayload,
        buy_product_id: Number(offerForm.buy_product_id),
        buy_product_name: selectedBuyProduct?.name || '',
        buy_quantity: Math.max(1, Number(offerForm.buy_quantity || 1)),
        get_product_id: Number(offerForm.get_product_id),
        get_product_name: selectedGetProduct?.name || '',
        get_quantity: Math.max(1, Number(offerForm.get_quantity || 1)),
        reward_type: offerForm.reward_type || 'flat_price',
        reward_value: offerForm.reward_type === 'free' ? 0 : toNumber(offerForm.reward_value, 0),
        offer_json: {
          offer_type: type,
          offer_name: offerForm.offer_name.trim(),
          buy_product_id: Number(offerForm.buy_product_id),
          buy_product_name: selectedBuyProduct?.name || '',
          buy_quantity: Math.max(1, Number(offerForm.buy_quantity || 1)),
          get_product_id: Number(offerForm.get_product_id),
          get_product_name: selectedGetProduct?.name || '',
          get_quantity: Math.max(1, Number(offerForm.get_quantity || 1)),
          reward_type: offerForm.reward_type || 'flat_price',
          reward_value: offerForm.reward_type === 'free' ? 0 : toNumber(offerForm.reward_value, 0),
        },
      };
    }

    if (type === 'time_slot_offer') {
      return {
        ...basePayload,
        start_time: offerForm.start_time,
        end_time: offerForm.end_time,
        days_active: offerForm.days_active || [],
        discount_type: offerForm.discount_type,
        discount_value: toNumber(offerForm.discount_value, 0),
        addon_special_price: toNumber(offerForm.addon_special_price, 0),
        offer_json: {
          offer_type: type,
          offer_name: offerForm.offer_name.trim(),
          start_time: offerForm.start_time,
          end_time: offerForm.end_time,
          days_active: offerForm.days_active || [],
          discount_type: offerForm.discount_type,
          discount_value: toNumber(offerForm.discount_value, 0),
          special_price: toNumber(offerForm.addon_special_price, 0),
        },
      };
    }

    if (type === 'progressive_unlock') {
      const steps = (offerForm.progressive_steps || [])
        .filter((step) => toNumber(step.min_bill_amount, 0) > 0 && String(step.reward_label || '').trim())
        .map((step) => ({
          min_bill_amount: toNumber(step.min_bill_amount, 0),
          reward_label: String(step.reward_label || '').trim(),
          reward_type: step.reward_type || 'flat_price',
          reward_product_id: step.reward_product_id ? Number(step.reward_product_id) : null,
          reward_value: step.reward_type === 'free' ? 0 : toNumber(step.reward_value, 0),
        }))
        .sort((a, b) => a.min_bill_amount - b.min_bill_amount);

      return {
        ...basePayload,
        min_purchasing_price: steps[0]?.min_bill_amount || minPrice,
        min_bill_amount: steps[0]?.min_bill_amount || minPrice,
        progressive_steps: steps,
        offer_json: {
          offer_type: type,
          offer_name: offerForm.offer_name.trim(),
          progressive_steps: steps,
        },
      };
    }

    return basePayload;
  };

  const handleSubmitOffer = async (e) => {
    e.preventDefault();

    if (!validateOfferForm()) return;

    try {
      setSavingOffer(true);

      const payload = buildOfferPayload();

      const response = offerForm.id
        ? await axios.put(`${apiUrl}/offers/${offerForm.id}?userdb=true`, payload, {
            headers: authHeaders,
          })
        : await axios.post(`${apiUrl}/offers?userdb=true`, payload, {
            headers: authHeaders,
          });

      showToast(
        response.data?.message || (offerForm.id ? 'Offer update ho gaya.' : 'Offer add ho gaya.')
      );

      resetOfferForm();
      await fetchOffers();
    } catch (err) {
      console.error('Add/Update Offer Error:', err);
      showToast(err.response?.data?.error || 'Offer save failed.');
    } finally {
      setSavingOffer(false);
    }
  };

  const startEditOffer = (offer) => {
    const normalized = normalizeOfferFromApi(offer);
    const type = normalized.offer_type || 'bill_discount';

    const legacyItems = String(normalized.offer_text || '')
      .split(', ')
      .map((text) => {
        const [value, product] = text.split('₹ ');
        const parsedValue = parseFloat(value);

        const formattedValue =
          Number.isFinite(parsedValue) && parsedValue % 1 === 0
            ? parsedValue.toString()
            : value;

        return {
          value: formattedValue?.trim() || '',
          product: product || '',
        };
      })
      .filter((item) => item.value && item.product);

    let comboItems = normalized.combo_items || [];
    if (typeof comboItems === 'string') {
      try {
        comboItems = JSON.parse(comboItems);
      } catch {
        comboItems = [];
      }
    }

    const coinConfig = getCoinRewardConfig(normalized);

    setOfferForm({
      ...emptyOfferForm,
      id: normalized.id,
      offer_type: type,
      offer_name:
        normalized.offer_name ||
        normalized.combo_name ||
        normalized.offer_text ||
        '',
      order_type: normalized.order_type || 'individual',
      min_purchasing_price:
        normalized.min_purchasing_price ||
        normalized.min_bill_amount ||
        '',
      max_purchasing_price: normalized.max_purchasing_price || '',
      group_size: normalized.group_size || '',
      family_size: normalized.family_size || '',

      discount_type: normalized.discount_type || 'flat',
      discount_value: normalized.discount_value || '',
      max_discount: normalized.max_discount || '',

      coin_earn_percent: coinConfig.coin_earn_percent > 0 ? String(coinConfig.coin_earn_percent) : '',
      coin_min_bill_amount: coinConfig.coin_min_bill_amount > 0 ? String(coinConfig.coin_min_bill_amount) : '',
      coin_min_earn: coinConfig.coin_min_earn > 0 ? String(coinConfig.coin_min_earn) : '',
      coin_max_earn_per_order: coinConfig.coin_max_earn_per_order > 0 ? String(coinConfig.coin_max_earn_per_order) : '',
      coin_value_rupees: coinConfig.coin_value_rupees > 0 ? String(coinConfig.coin_value_rupees) : '',
      coin_min_redeem: coinConfig.coin_min_redeem > 0 ? String(coinConfig.coin_min_redeem) : '',
      coin_max_redeem_per_order: coinConfig.coin_max_redeem_per_order > 0 ? String(coinConfig.coin_max_redeem_per_order) : '',
      coin_min_order_for_redeem: coinConfig.coin_min_order_for_redeem > 0 ? String(coinConfig.coin_min_order_for_redeem) : '',
      coin_expiry_days: coinConfig.coin_expiry_days > 0 ? String(coinConfig.coin_expiry_days) : '',

      combo_items: Array.isArray(comboItems) && comboItems.length
        ? comboItems.map((item) => ({
            productId: item.productId || item.id || '',
            quantity: item.quantity || 1,
          }))
        : [{ ...emptyComboItem }, { ...emptyComboItem }],
      combo_price: normalized.combo_price || '',

      addon_product_id: normalized.addon_product_id || '',
      addon_special_price: normalized.addon_special_price || normalized.special_price || '',
      addon_original_price: normalized.addon_original_price || '',
      addon_cost_price: normalized.addon_cost_price || '',
      limit_per_order: normalized.limit_per_order || 1,

      buy_product_id: normalized.buy_product_id || '',
      buy_quantity: normalized.buy_quantity || 2,
      get_product_id: normalized.get_product_id || '',
      get_quantity: normalized.get_quantity || 1,
      reward_type: normalized.reward_type || 'flat_price',
      reward_value: normalized.reward_value || '',

      start_time: normalizeTimeValue(normalized.start_time || ''),
      end_time: normalizeTimeValue(normalized.end_time || ''),
      days_active: Array.isArray(normalized.days_active) && normalized.days_active.length
        ? normalized.days_active
        : ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
      progressive_steps: Array.isArray(normalized.progressive_steps) && normalized.progressive_steps.length
        ? normalized.progressive_steps.map((step) => ({
            min_bill_amount: step.min_bill_amount || '',
            reward_label: step.reward_label || '',
            reward_type: step.reward_type || 'flat_price',
            reward_product_id: step.reward_product_id || '',
            reward_value: step.reward_value || '',
          }))
        : [{ ...emptyProgressiveStep }, { ...emptyProgressiveStep }],

      safety_mode: normalized.safety_mode || 'balanced',
      min_final_margin_percent: normalized.min_final_margin_percent || 15,

      is_active: safeFlagToBool(normalized.is_active ?? true, true),

      offerItems: legacyItems.length ? legacyItems : [{ product: '', value: '' }],
    });

    setActiveTab('offers');

    window.setTimeout(() => {
      const el = document.querySelector('.ff-offer-builder-card');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 120);
  };

  const handleToggleOfferStatus = async (offer) => {
    const normalized = normalizeOfferFromApi(offer);

    try {
      const payload = {
        ...normalized,
        is_active: safeFlagToBool(normalized.is_active ?? true, true) ? 0 : 1,
      };

      await axios.put(`${apiUrl}/offers/${offer.id}?userdb=true`, payload, {
        headers: authHeaders,
      });

      showToast(payload.is_active ? 'Offer active ho gaya.' : 'Offer pause ho gaya.');
      await fetchOffers();
    } catch (err) {
      console.error('Toggle Offer Error:', err);
      showToast('Offer status update failed.');
    }
  };

  const handleDeleteOffer = async (id) => {
    const ok = window.confirm('Ye offer delete karna hai?');
    if (!ok) return;

    try {
      await axios.delete(`${apiUrl}/offers/${id}?userdb=true`, {
        headers: authHeaders,
      });

      showToast('Offer delete ho gaya.');
      setOffers((prev) => prev.filter((o) => Number(o.id) !== Number(id)));
    } catch (err) {
      console.error('Delete Offer Error:', err);
      showToast(err.response?.data?.error || 'Offer delete failed.');
    }
  };

  const saveSettings = async () => {
    try {
      setSavingSettings(true);

      const payload = buildSettingsPayload(settings);

      if (
        payload.delivery_eta_min !== null &&
        payload.delivery_eta_max !== null &&
        payload.delivery_eta_min > payload.delivery_eta_max
      ) {
        showToast('Minimum delivery time maximum se bada nahi hona chahiye.');
        return;
      }

      const response = await axios.put(`${apiUrl}/order-settings?userdb=true`, payload, {
        headers: {
          ...authHeaders,
          'Content-Type': 'application/json',
        },
      });

      showToast(response.data?.message || 'Settings DB me save ho gaya.');
      await fetchSettings();
    } catch (err) {
      console.error('Save Settings Error:', err);
      showToast(err.response?.data?.error || err.response?.data?.details || err.message || 'Settings save failed.');
    } finally {
      setSavingSettings(false);
    }
  };

  const getAvailabilityLabel = (product) => {
    const value = String(product.availability || '').toLowerCase();

    if (value === 'out_of_stock') return 'Out of Stock';
    if (value === 'unavailable' || value === 'off') return 'Unavailable';

    return 'In Stock';
  };

  const getAvailabilityClass = (product) => {
    const value = String(product.availability || '').toLowerCase();

    if (value === 'out_of_stock') return 'warning';
    if (value === 'unavailable' || value === 'off') return 'danger';

    return 'success';
  };

  if (!token) {
    return (
      <div className="ff-login-box">
        <div className="ff-login-card">
          <div className="ff-login-icon">🍔</div>
          <h2>Login Required</h2>
          <p>Fast Food Manager use karne ke liye pehle login karein.</p>
          <a href="/login" className="ff-primary-btn">
            Go to Login
          </a>
        </div>
      </div>
    );
  }

  const renderSidebar = () => (
    <aside className="ff-sidebar">
      <div className="ff-sidebar-brand">
        <div className="ff-brand-icon">🍔</div>

        <div>
          <strong>Fast Food</strong>
          <span>Manager</span>
        </div>
      </div>

      <nav className="ff-side-nav">
        {NAV_ITEMS.map((item) => (
          <button
            key={item.key}
            type="button"
            className={activeTab === item.key ? 'active' : ''}
            onClick={() => setActiveTab(item.key)}
          >
            <span>{item.icon}</span>
            {item.label}
          </button>
        ))}
      </nav>

      <div className="ff-sidebar-promo">
        <div className="ff-promo-food">🍟</div>
        <strong>Grow your sales</strong>
        <p>Add combo offers and boost orders.</p>

        <button type="button" onClick={() => setActiveTab('offers')}>
          Create Offer
        </button>
      </div>
    </aside>
  );

  const renderMobileBottomNav = () => (
    <nav className="ff-mobile-nav">
      {NAV_ITEMS.map((item) => (
        <button
          key={item.key}
          type="button"
          className={activeTab === item.key ? 'active' : ''}
          onClick={() => setActiveTab(item.key)}
        >
          <span>{item.icon}</span>
          <small>{item.label === 'Menu List' ? 'Menu' : item.label}</small>
        </button>
      ))}
    </nav>
  );

  const renderTopHeader = () => (
    <header className="ff-top-header">
      <div className="ff-top-title">
        <span className="ff-mode-badge">🍔 Fast Food</span>
        <h1>{activeTab === 'offers' ? 'Smart Offers & Combo Management' : 'Fast Food Manager'}</h1>
        <p>
          {activeTab === 'offers'
            ? 'Create smart offers that boost sales and protect profit margins.'
            : 'Menu, products, offers aur settings ko simple tarike se manage karein.'}
        </p>
      </div>

      <div className="ff-header-actions">
        <input
          ref={menuFileInputRef}
          type="file"
          accept="image/*"
          onChange={handleMenuImportFileChange}
          style={{ display: 'none' }}
        />
        <button
          type="button"
          className="ff-light-btn"
          onClick={refreshFastFoodData}
        >
          Refresh
        </button>

        <div className="ff-menu-head-actions">
          <button type="button" className="ff-light-btn" onClick={openMenuUploadPicker}>
            📷 Upload Menu
          </button>

          <button type="button" className="ff-primary-btn" onClick={() => setActiveTab('products')}>
            + Add Item
          </button>
        </div>
      </div>
    </header>
  );

  const renderSummaryCards = () => (
    <div className="ff-summary-grid">
      <button
        type="button"
        className="ff-summary-card red"
        onClick={() => {
          setShowTrendingOnly(false);
          setCategoryFilter('all');
          setAvailabilityFilter('all');
          setFoodTypeFilter('all');
          setActiveTab('menu');
        }}
      >
        <span>🍔</span>

        <div>
          <strong>{summary.totalItems}</strong>
          <p>Total Items</p>
          <small>View all</small>
        </div>
      </button>

      <button
        type="button"
        className="ff-summary-card yellow"
        onClick={() => {
          setShowTrendingOnly(true);
          setAvailabilityFilter('all');
          setFoodTypeFilter('all');
          setActiveTab('menu');
        }}
      >
        <span>🔥</span>

        <div>
          <strong>{summary.trendingItems}</strong>
          <p>Trending Items</p>
          <small>View all</small>
        </div>
      </button>

      <button type="button" className="ff-summary-card green" onClick={() => setActiveTab('offers')}>
        <span>🏷️</span>

        <div>
          <strong>{summary.activeOffers}</strong>
          <p>Active Offers</p>
          <small>View all</small>
        </div>
      </button>

      <button
        type="button"
        className="ff-summary-card orange"
        onClick={() => {
          setShowTrendingOnly(false);
          setCategoryFilter('all');
          setFoodTypeFilter('all');
          setAvailabilityFilter('unavailable');
          setActiveTab('menu');
        }}
      >
        <span>🚫</span>

        <div>
          <strong>{summary.unavailableItems}</strong>
          <p>Unavailable</p>
          <small>View all</small>
        </div>
      </button>
    </div>
  );

  const renderHome = () => (
    <div className="ff-home-grid">
      <section className="ff-card ff-home-main-card">
        <div className="ff-hero-card">
          <div>
            <h2>Hello, Vendor! 👋</h2>
            <p>Manage your menu and grow your fast food business.</p>
          </div>

          <div className="ff-hero-food">🍔🍟</div>
        </div>

        {renderSummaryCards()}

        <div className="ff-quick-actions">
          <button type="button" onClick={() => setActiveTab('products')}>
            <span>🍔</span>
            Add Product
          </button>

          <button type="button" onClick={() => setActiveTab('menu')}>
            <span>📋</span>
            Menu List
          </button>

          <button type="button" onClick={() => setActiveTab('offers')}>
            <span>🏷️</span>
            Offers
          </button>

          <button type="button" onClick={() => setActiveTab('settings')}>
            <span>⚙️</span>
            Settings
          </button>
        </div>
      </section>

      <section className="ff-card">
        <div className="ff-card-head">
          <div>
            <h2>Top Items</h2>
            <p>Trending ya latest menu items.</p>
          </div>

          <button type="button" className="ff-text-btn" onClick={() => setActiveTab('menu')}>
            View All
          </button>
        </div>

        <div className="ff-mini-list">
          {topItems.length === 0 ? (
            <div className="ff-empty-state">Abhi product nahi hai.</div>
          ) : (
            topItems.map((product) => {
              const foodBadge = getFoodBadge(product.food_type);

              return (
                <div key={product.id} className="ff-mini-product-row">
                  <div className="ff-mini-img">
                    {product.image ? (
                      <img src={getImageUrl(product.image)} alt={product.name} />
                    ) : (
                      <span>🍔</span>
                    )}
                  </div>

                  <div>
                    <strong>{product.name}</strong>
                    <span>{formatMoney(product.price)}</span>

                    <div className="ff-food-row">
                      <small className={`ff-food-badge ${foodBadge.className}`}>
                        {foodBadge.label}
                      </small>

                      <small className={getAvailabilityClass(product)}>
                        {getAvailabilityLabel(product)}
                      </small>
                    </div>
                  </div>

                  <button type="button" onClick={() => startEditProduct(product)}>
                    Edit
                  </button>
                </div>
              );
            })
          )}
        </div>
      </section>
    </div>
  );

  const renderProductForm = () => (
    <form className="ff-card ff-product-form-card" onSubmit={handleSubmitProduct}>
      <div className="ff-card-head">
        <div>
          <h2>{form.id ? 'Edit Product' : 'Add Product'}</h2>
          <p>Fast food item ke basic details add karein.</p>
        </div>

        {voiceSupported ? (
          <button type="button" className="ff-light-btn" onClick={handleVoiceInput}>
            {isListening ? 'Listening...' : '🎤 Voice'}
          </button>
        ) : null}
      </div>

      <div className="ff-photo-box" onClick={() => fileInputRef.current?.click()}>
        {previewUrl ? (
          <img src={previewUrl} alt="Product Preview" />
        ) : (
          <div>
            <span>☁️</span>
            <strong>Tap to upload image</strong>
            <small>Product photo</small>
          </div>
        )}

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          name="image"
          onChange={handleProductChange}
          hidden
        />
      </div>

      <div className="ff-form-grid">
        <label>
          <span>Product Name *</span>
          <input
            name="name"
            value={form.name}
            onChange={handleProductChange}
            placeholder="Enter product name"
            required
          />
        </label>

        <label>
          <span>Category *</span>

          <select
            name="category"
            value={form.category}
            onChange={handleCategorySelect}
            required
          >
            <option value="">Select category</option>

            {categoryOptions.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}

            <option value={ADD_NEW_CATEGORY_VALUE}>➕ Add New Category</option>
          </select>

          {showNewCategoryInput ? (
            <div className="ff-new-category-box">
              <input
                type="text"
                value={newCategoryName}
                onChange={(e) => setNewCategoryName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleAddNewCategory();
                  }
                }}
                placeholder="Enter new category name"
                autoFocus
              />

              <button
                type="button"
                className="ff-new-category-add-btn"
                onClick={handleAddNewCategory}
              >
                Add
              </button>

              <button
                type="button"
                className="ff-new-category-cancel-btn"
                onClick={handleCancelNewCategory}
              >
                Cancel
              </button>
            </div>
          ) : null}
        </label>

        <label>
          <span>Selling Price ₹ *</span>

          <input
            name="price"
            type="number"
            step="0.01"
            min="0"
            value={form.price}
            onChange={handleProductChange}
            placeholder="Enter price"
            required
          />
        </label>

        <label>
          <span>Cost Price ₹</span>

          <input
            name="cost_price"
            type="number"
            step="0.01"
            min="0"
            value={form.cost_price}
            onChange={handleProductChange}
            placeholder="For safe offers"
          />
        </label>

        <label>
          <span>Availability</span>

          <select name="availability" value={form.availability} onChange={handleProductChange}>
            <option value="in_stock">In Stock</option>
            <option value="out_of_stock">Out of Stock</option>
            <option value="unavailable">Unavailable</option>
          </select>
        </label>
      </div>

      <div className="ff-food-type-row">
        <span>Food Type</span>

        <div className="ff-segment-control">
          <button
            type="button"
            className={form.food_type === 'veg' ? 'active veg' : ''}
            onClick={() => setForm((prev) => ({ ...prev, food_type: 'veg' }))}
          >
            🟢 Veg
          </button>

          <button
            type="button"
            className={form.food_type === 'non_veg' ? 'active nonveg' : ''}
            onClick={() => setForm((prev) => ({ ...prev, food_type: 'non_veg' }))}
          >
            🔴 Non-Veg
          </button>

          <button
            type="button"
            className={form.food_type === 'egg' ? 'active egg' : ''}
            onClick={() => setForm((prev) => ({ ...prev, food_type: 'egg' }))}
          >
            🟡 Egg
          </button>
        </div>
      </div>

      <label className="ff-check-card">
        <input
          type="checkbox"
          name="trend_item"
          checked={Boolean(form.trend_item)}
          onChange={handleProductChange}
        />

        <span>
          <strong>Trending / Best Seller</strong>
          <small>Customer menu me highlight dikhega.</small>
        </span>
      </label>

      <label className="ff-full-field">
        <span>Description</span>

        <textarea
          name="description"
          value={form.description}
          onChange={handleProductChange}
          placeholder="Optional product note"
        />
      </label>

      <div className="ff-form-actions">
        <button type="submit" className="ff-primary-btn" disabled={savingProduct}>
          {savingProduct ? 'Saving...' : form.id ? 'Update Product' : 'Save Product'}
        </button>

        <button type="button" className="ff-light-btn" onClick={resetProductForm}>
          Clear
        </button>
      </div>
    </form>
  );

  const renderProductsTab = () => (
    <div className="ff-two-column-layout">
      {renderProductForm()}

      <section className="ff-card ff-side-help-card">
        <h3>Fast Food Tips</h3>

        <p>Customer ko item ka naam, price aur image clear dikhna chahiye.</p>

        <div className="ff-help-point">Burger, Pizza, Snacks jaise category use karein.</div>
        <div className="ff-help-point">Veg / Non-Veg badge clear rakhein.</div>
        <div className="ff-help-point">Cost price add karne se safe offer calculation accurate hoga.</div>

        <button type="button" className="ff-primary-btn" onClick={() => setActiveTab('menu')}>
          View Menu List
        </button>
      </section>
    </div>
  );

  const isMenuProductSelected = (productId) =>
    selectedMenuItemIds.some((id) => Number(id) === Number(productId));

  const toggleMenuItemSelection = (productId) => {
    setSelectedMenuItemIds((prev) => {
      const exists = prev.some((id) => Number(id) === Number(productId));

      if (exists) {
        return prev.filter((id) => Number(id) !== Number(productId));
      }

      return [...prev, productId];
    });
  };

  const visibleMenuIds = filteredProducts.map((product) => product.id);

  const allVisibleMenuItemsSelected =
    visibleMenuIds.length > 0 &&
    visibleMenuIds.every((id) =>
      selectedMenuItemIds.some((selectedId) => Number(selectedId) === Number(id))
    );

  const toggleSelectAllVisibleMenuItems = () => {
    setSelectedMenuItemIds((prev) => {
      if (allVisibleMenuItemsSelected) {
        return prev.filter(
          (selectedId) =>
            !visibleMenuIds.some((id) => Number(id) === Number(selectedId))
        );
      }

      const next = [...prev];

      visibleMenuIds.forEach((id) => {
        if (!next.some((selectedId) => Number(selectedId) === Number(id))) {
          next.push(id);
        }
      });

      return next;
    });
  };

  const clearQuickMenuSelection = () => {
    setSelectedMenuItemIds([]);
  };

  const openQuickMenuManager = () => {
    setSelectedMenuItemIds([]);
    setQuickDescriptions(
      products.reduce((acc, product) => {
        acc[product.id] = product.description || '';
        return acc;
      }, {})
    );
    setMenuManageMode(true);
  };

  const closeQuickMenuManager = () => {
    setSelectedMenuItemIds([]);
    setMenuManageMode(false);
  };

  const buildProductUpdateFormData = (product, overrides = {}) => {
    const formData = new FormData();

    formData.append('name', overrides.name ?? product.name ?? '');
    formData.append('price', overrides.price ?? product.price ?? 0);
    formData.append('cost_price', overrides.cost_price ?? product.cost_price ?? 0);
    formData.append('category', overrides.category ?? product.category ?? 'Others');
    formData.append(
      'trend_item',
      String(
        overrides.trend_item !== undefined
          ? overrides.trend_item
            ? 1
            : 0
          : Number(product.trend_item) === 1
            ? 1
            : 0
      )
    );
    formData.append('food_type', overrides.food_type ?? product.food_type ?? 'veg');
    formData.append(
      'availability',
      overrides.availability ?? product.availability ?? 'in_stock'
    );
    formData.append(
      'description',
      overrides.description ?? product.description ?? ''
    );

    return formData;
  };

  const updateSingleProductQuickly = async (product, overrides = {}) => {
    const formData = buildProductUpdateFormData(product, overrides);

    await axios.put(
      `${apiUrl}/products/${product.id}?userdb=true`,
      formData,
      {
        headers: {
          ...authHeaders,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  };

  const saveQuickDescription = async (product) => {
    const nextDescription = String(
      quickDescriptions[product.id] ?? product.description ?? ''
    );

    if (nextDescription === String(product.description || '')) return;

    try {
      await updateSingleProductQuickly(product, {
        description: nextDescription,
      });

      setProducts((prev) =>
        prev.map((item) =>
          Number(item.id) === Number(product.id)
            ? { ...item, description: nextDescription }
            : item
        )
      );

      showToast(`${product.name} description update ho gaya.`);
    } catch (err) {
      console.error('Quick Description Update Error:', err);
      showToast(
        err.response?.data?.error ||
          `${product.name} description update failed.`
      );
    }
  };

  const handleBulkMenuAvailability = async (nextAvailability) => {
    if (!selectedMenuItemIds.length) {
      showToast('Pehle item select karein.');
      return;
    }

    const selectedProducts = products.filter((product) =>
      selectedMenuItemIds.some(
        (selectedId) => Number(selectedId) === Number(product.id)
      )
    );

    if (!selectedProducts.length) {
      showToast('Selected products nahi mile.');
      return;
    }

    try {
      setBulkAvailabilitySaving(true);

      await Promise.all(
        selectedProducts.map((product) =>
          updateSingleProductQuickly(product, {
            availability: nextAvailability,
            description:
              quickDescriptions[product.id] ?? product.description ?? '',
          })
        )
      );

      setProducts((prev) =>
        prev.map((product) => {
          if (
            !selectedMenuItemIds.some(
              (selectedId) => Number(selectedId) === Number(product.id)
            )
          ) {
            return product;
          }

          return {
            ...product,
            availability: nextAvailability,
            description:
              quickDescriptions[product.id] ?? product.description ?? '',
          };
        })
      );

      const actionText =
        nextAvailability === 'in_stock' ? 'Active' : 'Inactive';

      showToast(
        `${selectedProducts.length} item ${actionText} ho gaye.`
      );

      setSelectedMenuItemIds([]);
    } catch (err) {
      console.error('Bulk Availability Update Error:', err);
      showToast(
        err.response?.data?.error || 'Bulk availability update failed.'
      );
      await fetchProducts();
    } finally {
      setBulkAvailabilitySaving(false);
    }
  };

  const renderQuickMenuManager = () => (
    <div className="ff-quick-menu-manager">
      <div className="ff-quick-manager-top">
        <div>
          <h3>⚡ Quick Active / Inactive Manager</h3>
          <p>
            Item select karke ek click me active ya inactive karein.
          </p>
        </div>

        <button
          type="button"
          className="ff-light-btn ff-quick-manager-done"
          onClick={closeQuickMenuManager}
          disabled={bulkAvailabilitySaving}
        >
          ← Back to Menu List
        </button>
      </div>

      <div className="ff-quick-manager-filters">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search product..."
        />

        <select
          value={categoryFilter}
          onChange={(e) => setCategoryFilter(e.target.value)}
        >
          <option value="all">All Categories</option>
          {categoryOptions.map((category) => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>

        <select
          value={availabilityFilter}
          onChange={(e) => setAvailabilityFilter(e.target.value)}
        >
          <option value="all">All Status</option>
          <option value="in_stock">Active</option>
          <option value="unavailable">Inactive</option>
        </select>
      </div>

      <div className="ff-quick-manager-actions">
        <label className="ff-quick-select-all">
          <input
            type="checkbox"
            checked={allVisibleMenuItemsSelected}
            onChange={toggleSelectAllVisibleMenuItems}
          />
          <span>
            Select All ({filteredProducts.length})
          </span>
        </label>

        <strong className="ff-quick-selected-count">
          Selected: {selectedMenuItemIds.length}
        </strong>

        <div className="ff-quick-action-buttons">
          <button
            type="button"
            className="ff-quick-active-btn"
            onClick={() => handleBulkMenuAvailability('in_stock')}
            disabled={!selectedMenuItemIds.length || bulkAvailabilitySaving}
          >
            {bulkAvailabilitySaving ? 'Saving...' : '✓ Activate Selected'}
          </button>

          <button
            type="button"
            className="ff-quick-inactive-btn"
            onClick={() => handleBulkMenuAvailability('unavailable')}
            disabled={!selectedMenuItemIds.length || bulkAvailabilitySaving}
          >
            {bulkAvailabilitySaving ? 'Saving...' : '✕ Deactivate Selected'}
          </button>

          {selectedMenuItemIds.length > 0 ? (
            <button
              type="button"
              className="ff-quick-clear-btn"
              onClick={clearQuickMenuSelection}
              disabled={bulkAvailabilitySaving}
            >
              Clear
            </button>
          ) : null}
        </div>
      </div>

      {loadingProducts ? (
        <div className="ff-empty-state">Products loading...</div>
      ) : filteredProducts.length === 0 ? (
        <div className="ff-empty-state">Product nahi mila.</div>
      ) : (
        <div className="ff-quick-product-list">
          {filteredProducts.map((product) => {
            const selected = isMenuProductSelected(product.id);
            const isActive =
              String(product.availability || '').toLowerCase() === 'in_stock';

            return (
              <div
                key={product.id}
                className={
                  selected
                    ? 'ff-quick-product-row selected'
                    : 'ff-quick-product-row'
                }
              >
                <div className="ff-quick-product-main">
                  <div className="ff-quick-product-title-row">
                    <strong>{product.name}</strong>
                    <span
                      className={
                        isActive
                          ? 'ff-quick-status active'
                          : 'ff-quick-status inactive'
                      }
                    >
                      {isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>

                  <input
                    className="ff-quick-description-input"
                    value={
                      quickDescriptions[product.id] ??
                      product.description ??
                      ''
                    }
                    onChange={(e) =>
                      setQuickDescriptions((prev) => ({
                        ...prev,
                        [product.id]: e.target.value,
                      }))
                    }
                    onBlur={() => saveQuickDescription(product)}
                    placeholder="Description add karein..."
                  />
                </div>

                <label className="ff-quick-product-check">
                  <input
                    type="checkbox"
                    checked={selected}
                    onChange={() =>
                      toggleMenuItemSelection(product.id)
                    }
                    aria-label={`Select ${product.name}`}
                  />
                </label>
              </div>
            );
          })}
        </div>
      )}

      <div className="ff-list-footer">
        Showing {filteredProducts.length} of {products.length} items
      </div>
    </div>
  );

  const renderDesktopMenuRow = (product) => {
    const isEditing = Number(inlineEditingId) === Number(product.id);
    const foodBadge = getFoodBadge(product.food_type);
    const fullDescription = product.description || 'Fast food item';
    const expanded = expandedDescriptions[product.id];

    if (isEditing) {
      return (
        <div className="ff-menu-row ff-menu-row-editing" key={product.id}>
          <div className="ff-product-info">
            <label className="ff-inline-img-picker">
              {inlineImagePreview ? (
                <img src={inlineImagePreview} alt={inlineEditData.name || 'Product'} />
              ) : (
                <span>📷</span>
              )}

              <small>Change</small>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleInlineImageChange(e.target.files?.[0])}
                hidden
              />
            </label>

            <div className="ff-product-details-block">
              <input
                className="ff-inline-input"
                value={inlineEditData.name || ''}
                onChange={(e) => handleInlineChange('name', e.target.value)}
                placeholder="Product name"
              />

              <textarea
                className="ff-inline-textarea"
                value={inlineEditData.description || ''}
                onChange={(e) => handleInlineChange('description', e.target.value)}
                placeholder="Description"
              />
            </div>
          </div>

          <div className="ff-inline-stack">
            <select
              className="ff-inline-select"
              value={inlineEditData.category || 'Others'}
              onChange={(e) => handleInlineChange('category', e.target.value)}
            >
              {categoryOptions.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>

            <select
              className="ff-inline-select"
              value={inlineEditData.food_type || 'veg'}
              onChange={(e) => handleInlineChange('food_type', e.target.value)}
            >
              <option value="veg">🟢 Veg</option>
              <option value="non_veg">🔴 Non-Veg</option>
              <option value="egg">🟡 Egg</option>
            </select>
          </div>

          <input
            type="number"
            className="ff-inline-price"
            value={inlineEditData.price || ''}
            onChange={(e) => handleInlineChange('price', e.target.value)}
            placeholder="Price"
          />

          <input
            type="number"
            className="ff-inline-price"
            value={inlineEditData.cost_price || ''}
            onChange={(e) => handleInlineChange('cost_price', e.target.value)}
            placeholder="Cost"
          />

          <select
            className="ff-inline-select"
            value={inlineEditData.availability || 'in_stock'}
            onChange={(e) => handleInlineChange('availability', e.target.value)}
          >
            <option value="in_stock">In Stock</option>
            <option value="out_of_stock">Out of Stock</option>
            <option value="unavailable">Unavailable</option>
          </select>

          <button
            type="button"
            className={inlineEditData.trend_item ? 'ff-fire active' : 'ff-fire'}
            onClick={() => handleInlineChange('trend_item', !inlineEditData.trend_item)}
            title="Toggle trending"
          >
            🔥
          </button>

          <div className="ff-row-actions ff-editing-actions">
            <button type="button" className="ff-save-btn" onClick={saveInlineEdit} disabled={savingInlineEdit}>
              {savingInlineEdit ? 'Saving...' : 'Save'}
            </button>

            <button type="button" className="ff-cancel-btn" onClick={cancelInlineEdit}>
              Cancel
            </button>

            <button type="button" className="ff-more-edit-btn" onClick={() => startEditProduct(product)}>
              More Edit
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="ff-menu-row" key={product.id}>
        <div className="ff-product-info">
          <div className="ff-product-img">
            {product.image ? (
              <img src={getImageUrl(product.image)} alt={product.name} />
            ) : (
              <span>🍔</span>
            )}
          </div>

          <div className="ff-product-details-block">
            <strong>{product.name}</strong>

            <div className="ff-food-row">
              <span className={`ff-food-badge ${foodBadge.className}`}>
                {foodBadge.label}
              </span>

              <span className="ff-category-badge">{product.category || 'Others'}</span>
            </div>

            <small className="ff-description-text">
              {expanded ? fullDescription : getShortDescription(fullDescription, 3)}

              {shouldShowReadMore(fullDescription, 3) ? (
                <button
                  type="button"
                  className="ff-read-more"
                  onClick={() => toggleDescription(product.id)}
                >
                  {expanded ? 'Show Less' : 'Read More'}
                </button>
              ) : null}
            </small>
          </div>
        </div>

        <span className="ff-category-badge ff-desktop-food-type">
          {foodBadge.label}
        </span>

        <span className="ff-price-text">{formatMoney(product.price)}</span>

        <span className={`ff-status-pill ${getAvailabilityClass(product)}`}>
          {getAvailabilityLabel(product)}
        </span>

        <button
          type="button"
          className={Number(product.trend_item) === 1 ? 'ff-fire active' : 'ff-fire'}
          onClick={() => handleQuickToggleTrending(product)}
          title="Toggle trending"
        >
          🔥
        </button>

        <div className="ff-row-actions">
          <button type="button" className="ff-edit-btn" onClick={() => startInlineEdit(product)}>
            Edit
          </button>

          <button
            type="button"
            className="ff-delete-icon-btn"
            onClick={() => handleDeleteProduct(product.id)}
            title="Delete product"
            aria-label="Delete product"
          >
            🗑️
          </button>
        </div>
      </div>
    );
  };

  const renderMobileMenuCard = (product) => {
    const isEditing = Number(inlineEditingId) === Number(product.id);
    const foodBadge = getFoodBadge(product.food_type);
    const fullDescription = product.description || 'Fast food item';
    const expanded = expandedDescriptions[product.id];

    if (isEditing) {
      return (
        <div className="ff-mobile-product-card ff-mobile-product-card-editing" key={product.id}>
          <div className="ff-mobile-edit-top">
            <label className="ff-mobile-inline-img-picker">
              {inlineImagePreview ? (
                <img src={inlineImagePreview} alt={inlineEditData.name || 'Product'} />
              ) : (
                <span>📷</span>
              )}

              <small>Change</small>

              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleInlineImageChange(e.target.files?.[0])}
                hidden
              />
            </label>

            <div className="ff-mobile-edit-main">
              <input
                className="ff-inline-input"
                value={inlineEditData.name || ''}
                onChange={(e) => handleInlineChange('name', e.target.value)}
                placeholder="Product name"
              />

              <input
                type="number"
                className="ff-inline-input"
                value={inlineEditData.price || ''}
                onChange={(e) => handleInlineChange('price', e.target.value)}
                placeholder="Price"
              />

              <input
                type="number"
                className="ff-inline-input"
                value={inlineEditData.cost_price || ''}
                onChange={(e) => handleInlineChange('cost_price', e.target.value)}
                placeholder="Cost price"
              />
            </div>
          </div>

          <div className="ff-mobile-edit-grid">
            <select
              className="ff-inline-select"
              value={inlineEditData.category || 'Others'}
              onChange={(e) => handleInlineChange('category', e.target.value)}
            >
              {categoryOptions.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>

            <select
              className="ff-inline-select"
              value={inlineEditData.food_type || 'veg'}
              onChange={(e) => handleInlineChange('food_type', e.target.value)}
            >
              <option value="veg">🟢 Veg</option>
              <option value="non_veg">🔴 Non-Veg</option>
              <option value="egg">🟡 Egg</option>
            </select>

            <select
              className="ff-inline-select"
              value={inlineEditData.availability || 'in_stock'}
              onChange={(e) => handleInlineChange('availability', e.target.value)}
            >
              <option value="in_stock">In Stock</option>
              <option value="out_of_stock">Out of Stock</option>
              <option value="unavailable">Unavailable</option>
            </select>

            <button
              type="button"
              className={inlineEditData.trend_item ? 'ff-mobile-trend-btn active' : 'ff-mobile-trend-btn'}
              onClick={() => handleInlineChange('trend_item', !inlineEditData.trend_item)}
            >
              🔥 Trending
            </button>
          </div>

          <textarea
            className="ff-inline-textarea ff-mobile-inline-textarea"
            value={inlineEditData.description || ''}
            onChange={(e) => handleInlineChange('description', e.target.value)}
            placeholder="Description"
          />

          <div className="ff-mobile-edit-actions">
            <button type="button" className="ff-save-btn" onClick={saveInlineEdit} disabled={savingInlineEdit}>
              {savingInlineEdit ? 'Saving...' : 'Save'}
            </button>

            <button type="button" className="ff-cancel-btn" onClick={cancelInlineEdit}>
              Cancel
            </button>

            <button type="button" className="ff-more-edit-btn" onClick={() => startEditProduct(product)}>
              More Edit
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="ff-mobile-product-card" key={product.id}>
        <div className="ff-product-img">
          {product.image ? (
            <img src={getImageUrl(product.image)} alt={product.name} />
          ) : (
            <span>🍔</span>
          )}
        </div>

        <div className="ff-mobile-product-body">
          <div className="ff-mobile-title-row">
            <strong>{product.name}</strong>
            <span>{formatMoney(product.price)}</span>
          </div>

          <div className="ff-mobile-food-row">
            <span className={`ff-food-badge ${foodBadge.className}`}>
              {foodBadge.label}
            </span>

            <small>{product.category || 'Others'}</small>
          </div>

          <small className="ff-mobile-description">
            {expanded ? fullDescription : getShortDescription(fullDescription, 4)}

            {shouldShowReadMore(fullDescription, 4) ? (
              <button
                type="button"
                className="ff-read-more"
                onClick={() => toggleDescription(product.id)}
              >
                {expanded ? 'Show Less' : 'Read More'}
              </button>
            ) : null}
          </small>

          <div className="ff-mobile-status-row">
            <b className={getAvailabilityClass(product)}>{getAvailabilityLabel(product)}</b>

            <button
              type="button"
              className={Number(product.trend_item) === 1 ? 'ff-mobile-fire active' : 'ff-mobile-fire'}
              onClick={() => handleQuickToggleTrending(product)}
              title="Toggle trending"
            >
              🔥
            </button>
          </div>
        </div>

        <div className="ff-mobile-card-actions">
          <button type="button" className="ff-edit-btn" onClick={() => startInlineEdit(product)}>
            Edit
          </button>

          <button
            type="button"
            className="ff-delete-icon-btn"
            onClick={() => handleDeleteProduct(product.id)}
            title="Delete product"
            aria-label="Delete product"
          >
            🗑️
          </button>
        </div>
      </div>
    );
  };

  const renderMenuList = () => (
    <section className="ff-card ff-menu-card">
      <div className="ff-card-head">
        <div>
          <h2>Menu List</h2>
          <p>
            {menuManageMode
              ? 'Fast active / inactive management mode.'
              : 'Search, filter aur quick edit ke saath complete menu.'}
          </p>
        </div>

        <div className="ff-menu-head-actions">
          {!menuManageMode ? (
            <>
              <button
                type="button"
                className="ff-light-btn ff-manage-menu-btn"
                onClick={openQuickMenuManager}
              >
                ⚡ Active / Inactive Edit
              </button>

              <button
                type="button"
                className="ff-primary-btn"
                onClick={() => setActiveTab('products')}
              >
                + Add Item
              </button>
            </>
          ) : null}
        </div>
      </div>

      {menuManageMode ? (
        renderQuickMenuManager()
      ) : (
        <>
          {renderAiMenuImportPanel()}

          <div className="ff-filter-bar">
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search items..."
            />

            <select
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
            >
              <option value="all">All Categories</option>

              {categoryOptions.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>

            <select
              value={availabilityFilter}
              onChange={(e) => setAvailabilityFilter(e.target.value)}
            >
              <option value="all">All Availability</option>
              <option value="in_stock">In Stock</option>
              <option value="out_of_stock">Out of Stock</option>
              <option value="unavailable">Unavailable</option>
            </select>

            <select
              value={foodTypeFilter}
              onChange={(e) => setFoodTypeFilter(e.target.value)}
            >
              <option value="all">All Food Type</option>
              <option value="veg">Veg</option>
              <option value="non_veg">Non-Veg</option>
              <option value="egg">Egg</option>
            </select>

            <button
              type="button"
              className={showTrendingOnly ? 'active' : ''}
              onClick={() => setShowTrendingOnly((prev) => !prev)}
            >
              🔥 Trending
            </button>
          </div>

          {loadingProducts ? (
            <div className="ff-empty-state">Products loading...</div>
          ) : filteredProducts.length === 0 ? (
            <div className="ff-empty-state">Product nahi mila.</div>
          ) : (
            <>
              <div className="ff-menu-table">
                <div className="ff-menu-row ff-menu-head-row">
                  <span>Item</span>
                  <span>Food Type</span>
                  <span>Price</span>
                  <span>Availability</span>
                  <span>Trending</span>
                  <span>Actions</span>
                </div>

                {filteredProducts.map(renderDesktopMenuRow)}
              </div>

              <div className="ff-mobile-menu-list">
                {filteredProducts.map(renderMobileMenuCard)}
              </div>
            </>
          )}

          <div className="ff-list-footer">
            Showing {filteredProducts.length} of {products.length} items
          </div>
        </>
      )}
    </section>
  );

  const updateProgressiveStep = (index, field, value) => {
    setOfferForm((prev) => {
      const steps = [...(prev.progressive_steps || [])];
      steps[index] = {
        ...(steps[index] || { ...emptyProgressiveStep }),
        [field]: value,
      };
      return { ...prev, progressive_steps: steps };
    });
  };

  const addProgressiveStep = () => {
    setOfferForm((prev) => ({
      ...prev,
      progressive_steps: [...(prev.progressive_steps || []), { ...emptyProgressiveStep }],
    }));
  };

  const removeProgressiveStep = (index) => {
    setOfferForm((prev) => ({
      ...prev,
      progressive_steps: (prev.progressive_steps || []).filter((_, i) => i !== index),
    }));
  };

  const toggleOfferDay = (dayKey) => {
    setOfferForm((prev) => {
      const days = Array.isArray(prev.days_active) ? prev.days_active : [];
      const exists = days.includes(dayKey);
      return {
        ...prev,
        days_active: exists ? days.filter((day) => day !== dayKey) : [...days, dayKey],
      };
    });
  };

  const renderOfferTypeCards = () => (
    <div className="ff-offer-type-grid">
      {Object.values(OFFER_TYPES).map((type) => (
        <button
          key={type.key}
          type="button"
          className={offerForm.offer_type === type.key ? 'ff-offer-type-card active' : 'ff-offer-type-card'}
          onClick={() => setOfferType(type.key)}
        >
          <span>{type.icon}</span>
          <strong>{type.label}</strong>
          <small>{type.note}</small>
        </button>
      ))}
    </div>
  );

  const renderOfferDashboard = () => (
    <div className="ff-offers-dashboard">
      <div className="ff-offer-stat-card safe">
        <span>🛡️</span>
        <div>
          <strong>{offerStats.activeOffers}</strong>
          <p>Active Offers</p>
          <small>Live on customer QR</small>
        </div>
      </div>

      <div className="ff-offer-stat-card pause">
        <span>⏸️</span>
        <div>
          <strong>{offerStats.pausedOffers}</strong>
          <p>Paused Offers</p>
          <small>Hidden from customers</small>
        </div>
      </div>

      <div className="ff-offer-stat-card safe">
        <span>✅</span>
        <div>
          <strong>{offerStats.safeOffers}</strong>
          <p>Safe Offers</p>
          <small>Loss-proof checks</small>
        </div>
      </div>

      <div className="ff-offer-stat-card combo">
        <span>📦</span>
        <div>
          <strong>{offerStats.totalComboSets}</strong>
          <p>Total Combo Sets</p>
          <small>Value meals</small>
        </div>
      </div>
    </div>
  );

  const renderSafetyPanel = () => (
    <div className={offerSafety.safe ? 'ff-safety-panel safe' : 'ff-safety-panel unsafe'}>
      <div className="ff-safety-head">
        <span>{offerSafety.safe ? '✅' : '❌'}</span>
        <strong>{offerSafety.label}</strong>
      </div>

      <p>{offerSafety.message}</p>

      {!offerSafety.safe ? (
        <div className="ff-safety-suggest">
          <span>Suggested</span>
          <b>{offerSafety.suggestion}</b>

          {offerSafety.minimumSafePrice > 0 ? (
            <button
              type="button"
              onClick={() => {
                if (offerForm.offer_type === 'combo') {
                  setOfferForm((prev) => ({
                    ...prev,
                    combo_price: String(offerSafety.minimumSafePrice),
                  }));
                }

                if (offerForm.offer_type === 'bill_unlock_addon') {
                  setOfferForm((prev) => ({
                    ...prev,
                    addon_special_price: String(offerSafety.minimumSafePrice),
                  }));
                }
              }}
            >
              Use Safe Price
            </button>
          ) : null}
        </div>
      ) : (
        <div className="ff-safety-profit">
          <span>Estimated Margin</span>
          <b>
            {formatMoney(offerSafety.marginAmount)} ({Number(offerSafety.marginPercent || 0).toFixed(1)}%)
          </b>
          <small>This offer is safe for your business.</small>
        </div>
      )}
    </div>
  );

  const renderComboBuilder = () => (
    <div className="ff-offer-builder-section">
      <div className="ff-offer-builder-title">
        <span>🍔</span>
        <div>
          <h3>Create Combo Set</h3>
          <p>Burger + Fries + Coke jaise combo set bana sakte ho.</p>
        </div>
      </div>

      <div className="ff-form-grid">
        <label>
          <span>Combo Name *</span>
          <input
            value={offerForm.offer_name}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, offer_name: e.target.value }))}
            placeholder="Burger Meal Combo"
          />
        </label>

        <label>
          <span>Combo Price ₹ *</span>
          <input
            type="number"
            min="0"
            step="0.01"
            value={offerForm.combo_price}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, combo_price: e.target.value }))}
            placeholder="199"
          />
        </label>
      </div>

      <div className="ff-combo-items-table">
        <div className="ff-combo-head-row ff-combo-head-row-with-image">
          <span>Selected Product</span>
          <span>Qty</span>
          <span>Actual Price</span>
          <span></span>
        </div>

        {(offerForm.combo_items || []).map((item, index) => {
          const product = getProductById(item.productId);
          const qty = Math.max(1, Number(item.quantity || 1));

          return (
            <div className="ff-combo-item-row ff-combo-item-row-with-image" key={index}>
              <div className="ff-combo-product-picker">
                <div className={product?.image ? 'ff-combo-product-thumb' : 'ff-combo-product-thumb empty'}>
                  {product?.image ? (
                    <img src={getImageUrl(product.image)} alt={product.name || 'Selected product'} />
                  ) : (
                    <span>🍔</span>
                  )}
                </div>

                <div className="ff-combo-product-select-box">
                  <select
                    value={item.productId}
                    onChange={(e) => updateComboItem(index, 'productId', e.target.value)}
                  >
                    <option value="">Select Product</option>
                    {products.map((productItem) => (
                      <option key={productItem.id} value={productItem.id}>
                        {productItem.name} - {formatMoney(productItem.price)}
                      </option>
                    ))}
                  </select>

                  {product ? (
                    <div className="ff-combo-selected-meta">
                      <strong>{product.name}</strong>
                      <span>{product.category || 'Others'} • {formatMoney(product.price)}</span>
                    </div>
                  ) : (
                    <small className="ff-combo-select-help">Product select karte hi image yahan dikhegi.</small>
                  )}
                </div>
              </div>

              <div className="ff-combo-qty">
                <button type="button" onClick={() => updateComboItem(index, 'quantity', Math.max(1, qty - 1))}>
                  -
                </button>
                <strong>{qty}</strong>
                <button type="button" onClick={() => updateComboItem(index, 'quantity', qty + 1)}>
                  +
                </button>
              </div>

              <strong>{formatMoney(getProductPrice(product) * qty)}</strong>

              <button
                type="button"
                className="ff-combo-remove"
                onClick={() => removeComboItem(index)}
                disabled={(offerForm.combo_items || []).length <= 1}
              >
                🗑️
              </button>
            </div>
          );
        })}

        <button type="button" className="ff-light-btn ff-add-combo-item" onClick={addComboItem}>
          + Add More Product
        </button>
      </div>

      {selectedComboItems.length ? (
        <div className="ff-combo-selected-preview">
          <div className="ff-section-title-row compact">
            <h3>Selected Combo Products</h3>
            <small>{selectedComboItems.length} products selected</small>
          </div>

          <div className="ff-combo-preview-list">
            {selectedComboItems.map((item) => (
              <div className="ff-combo-preview-chip" key={item.productId}>
                <div className={item.image ? 'ff-combo-preview-img' : 'ff-combo-preview-img empty'}>
                  {item.image ? (
                    <img src={getImageUrl(item.image)} alt={item.name} />
                  ) : (
                    <span>🍔</span>
                  )}
                </div>

                <div>
                  <strong>{item.name}</strong>
                  <small>Qty {item.quantity} × {formatMoney(item.price)}</small>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      <div className="ff-offer-calc-grid">
        <div>
          <span>Actual Price</span>
          <strong>{formatMoney(comboActualPrice)}</strong>
        </div>

        <div>
          <span>Combo Price</span>
          <strong className="danger">{formatMoney(offerForm.combo_price)}</strong>
        </div>

        <div>
          <span>Customer Save</span>
          <strong className="success">{formatMoney(comboCustomerSave)}</strong>
        </div>
      </div>
    </div>
  );

  const renderAddonBuilder = () => (
    <div className="ff-offer-builder-section">
      <div className="ff-offer-builder-title purple">
        <span>🔓</span>
        <div>
          <h3>Create Bill Unlock Add-on</h3>
          <p>Bill ₹500+ par pizza ₹50 jaisa smart add-on offer.</p>
        </div>
      </div>

      <div className="ff-addon-layout">
        <div>
          <div className="ff-form-grid">
            <label>
              <span>Offer Name *</span>
              <input
                value={offerForm.offer_name}
                onChange={(e) => setOfferForm((prev) => ({ ...prev, offer_name: e.target.value }))}
                placeholder="Pizza Deal"
              />
            </label>

            <label>
              <span>Minimum Bill Amount ₹ *</span>
              <input
                type="number"
                min="0"
                value={offerForm.min_purchasing_price}
                onChange={(e) => setOfferForm((prev) => ({ ...prev, min_purchasing_price: e.target.value }))}
                placeholder="500"
              />
            </label>

            <label>
              <span>Select Product *</span>
              <select
                value={offerForm.addon_product_id}
                onChange={(e) => {
                  const product = getProductById(e.target.value);
                  setOfferForm((prev) => ({
                    ...prev,
                    addon_product_id: e.target.value,
                    addon_original_price: product ? String(getProductPrice(product)) : '',
                    addon_cost_price: product ? String(getProductCost(product)) : '',
                  }));
                }}
              >
                <option value="">Select add-on product</option>
                {products.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.name} - {formatMoney(product.price)}
                  </option>
                ))}
              </select>
            </label>

            <label>
              <span>Original Price ₹</span>
              <input
                type="number"
                min="0"
                value={addonOriginalPrice || ''}
                onChange={(e) => setOfferForm((prev) => ({ ...prev, addon_original_price: e.target.value }))}
                placeholder="150"
              />
            </label>

            <label>
              <span>Cost Price ₹</span>
              <input
                type="number"
                min="0"
                value={addonCostPrice || ''}
                onChange={(e) => setOfferForm((prev) => ({ ...prev, addon_cost_price: e.target.value }))}
                placeholder="85"
              />
            </label>

            <label>
              <span>Special Offer Price ₹ *</span>
              <input
                type="number"
                min="0"
                value={offerForm.addon_special_price}
                onChange={(e) => setOfferForm((prev) => ({ ...prev, addon_special_price: e.target.value }))}
                placeholder="50"
              />
            </label>

            <label>
              <span>Limit Per Order</span>
              <input
                type="number"
                min="1"
                value={offerForm.limit_per_order}
                onChange={(e) => setOfferForm((prev) => ({ ...prev, limit_per_order: e.target.value }))}
                placeholder="1"
              />
            </label>

            <label>
              <span>Minimum Final Margin %</span>
              <input
                type="number"
                min="0"
                value={offerForm.min_final_margin_percent}
                onChange={(e) => setOfferForm((prev) => ({ ...prev, min_final_margin_percent: e.target.value }))}
                placeholder="15"
              />
            </label>
          </div>

          <div className="ff-safety-mode-box">
            <span>Safety Mode</span>
            <div className="ff-segment-control">
              {['safe', 'balanced', 'aggressive'].map((mode) => (
                <button
                  type="button"
                  key={mode}
                  className={offerForm.safety_mode === mode ? 'active veg' : ''}
                  onClick={() => {
                    const marginMap = {
                      safe: 25,
                      balanced: 15,
                      aggressive: 8,
                    };

                    setOfferForm((prev) => ({
                      ...prev,
                      safety_mode: mode,
                      min_final_margin_percent: marginMap[mode],
                    }));
                  }}
                >
                  {mode.charAt(0).toUpperCase() + mode.slice(1)}
                </button>
              ))}
            </div>
          </div>
        </div>

        {renderSafetyPanel()}
      </div>
    </div>
  );

  const renderBillDiscountBuilder = () => (
    <div className="ff-offer-builder-section">
      <div className="ff-offer-builder-title red">
        <span>🏷️</span>
        <div>
          <h3>Create Bill Discount</h3>
          <p>Minimum bill amount par flat ya percent discount.</p>
        </div>
      </div>

      <div className="ff-form-grid">
        <label>
          <span>Offer Name *</span>
          <input
            value={offerForm.offer_name}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, offer_name: e.target.value }))}
            placeholder="Weekend Discount"
          />
        </label>

        <label>
          <span>Minimum Bill ₹ *</span>
          <input
            type="number"
            min="0"
            value={offerForm.min_purchasing_price}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, min_purchasing_price: e.target.value }))}
            placeholder="500"
          />
        </label>

        <label>
          <span>Discount Type</span>
          <select
            value={offerForm.discount_type}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, discount_type: e.target.value }))}
          >
            <option value="flat">Flat ₹</option>
            <option value="percent">Percent %</option>
          </select>
        </label>

        <label>
          <span>Discount Value *</span>
          <input
            type="number"
            min="0"
            value={offerForm.discount_value}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, discount_value: e.target.value }))}
            placeholder={offerForm.discount_type === 'percent' ? '10' : '50'}
          />
        </label>

        <label>
          <span>Max Discount ₹</span>
          <input
            type="number"
            min="0"
            value={offerForm.max_discount}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, max_discount: e.target.value }))}
            placeholder="100"
          />
        </label>
      </div>

      <div className="ff-note-box">
        <strong>Preview:</strong> {calculateOffer()}
      </div>
    </div>
  );


  const renderBuyXGetYBuilder = () => (
    <div className="ff-offer-builder-section">
      <div className="ff-offer-builder-title green">
        <span>🎁</span>
        <div>
          <h3>Create Buy X Get Y</h3>
          <p>Example: Buy 2 Burger, get 1 Coke free ya ₹10 me.</p>
        </div>
      </div>

      <div className="ff-form-grid">
        <label>
          <span>Offer Name *</span>
          <input
            value={offerForm.offer_name}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, offer_name: e.target.value }))}
            placeholder="Burger Coke Deal"
          />
        </label>

        <label>
          <span>Buy Product *</span>
          <select
            value={offerForm.buy_product_id}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, buy_product_id: e.target.value }))}
          >
            <option value="">Select product</option>
            {products.map((product) => (
              <option key={product.id} value={product.id}>
                {product.name} - {formatMoney(product.price)}
              </option>
            ))}
          </select>
        </label>

        <label>
          <span>Buy Quantity *</span>
          <input
            type="number"
            min="1"
            value={offerForm.buy_quantity}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, buy_quantity: e.target.value }))}
            placeholder="2"
          />
        </label>

        <label>
          <span>Reward Product *</span>
          <select
            value={offerForm.get_product_id}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, get_product_id: e.target.value }))}
          >
            <option value="">Select reward product</option>
            {products.map((product) => (
              <option key={product.id} value={product.id}>
                {product.name} - {formatMoney(product.price)}
              </option>
            ))}
          </select>
        </label>

        <label>
          <span>Reward Quantity *</span>
          <input
            type="number"
            min="1"
            value={offerForm.get_quantity}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, get_quantity: e.target.value }))}
            placeholder="1"
          />
        </label>

        <label>
          <span>Reward Type</span>
          <select
            value={offerForm.reward_type}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, reward_type: e.target.value }))}
          >
            <option value="free">Free</option>
            <option value="flat_price">Special Price ₹</option>
            <option value="percent_discount">Percent Discount %</option>
          </select>
        </label>

        {offerForm.reward_type !== 'free' ? (
          <label>
            <span>{offerForm.reward_type === 'percent_discount' ? 'Discount %' : 'Special Price ₹'}</span>
            <input
              type="number"
              min="0"
              value={offerForm.reward_value}
              onChange={(e) => setOfferForm((prev) => ({ ...prev, reward_value: e.target.value }))}
              placeholder={offerForm.reward_type === 'percent_discount' ? '50' : '10'}
            />
          </label>
        ) : null}
      </div>

      <div className="ff-note-box">
        <strong>Preview:</strong> {calculateOffer()}
      </div>
    </div>
  );

  const renderTimeSlotOfferBuilder = () => (
    <div className="ff-offer-builder-section">
      <div className="ff-offer-builder-title purple">
        <span>⏰</span>
        <div>
          <h3>Create Time Slot Offer</h3>
          <p>Slow hours / happy hours ke liye limited time deal.</p>
        </div>
      </div>

      <div className="ff-form-grid">
        <label>
          <span>Offer Name *</span>
          <input
            value={offerForm.offer_name}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, offer_name: e.target.value }))}
            placeholder="Happy Hour Deal"
          />
        </label>

        <label>
          <span>Minimum Bill Amount ₹ *</span>
          <input
            type="number"
            min="0"
            step="0.01"
            value={offerForm.min_purchasing_price}
            onChange={(e) =>
              setOfferForm((prev) => ({
                ...prev,
                min_purchasing_price: e.target.value,
                min_bill_amount: e.target.value,
              }))
            }
            placeholder="Example: 299"
          />
        </label>

        <label className="ff-time-ampm-field">
          <span>Start Time *</span>
          <TimeAmPmInput
            value={offerForm.start_time}
            onChange={(value) => setOfferForm((prev) => ({ ...prev, start_time: value }))}
          />
          <small>{formatTimeAmPm(offerForm.start_time)}</small>
        </label>

        <label className="ff-time-ampm-field">
          <span>End Time *</span>
          <TimeAmPmInput
            value={offerForm.end_time}
            onChange={(value) => setOfferForm((prev) => ({ ...prev, end_time: value }))}
          />
          <small>{formatTimeAmPm(offerForm.end_time)}</small>
        </label>

        <label>
          <span>Discount Type</span>
          <select
            value={offerForm.discount_type}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, discount_type: e.target.value }))}
          >
            <option value="flat">Flat ₹ OFF</option>
            <option value="percent">Percent % OFF</option>
          </select>
        </label>

        <label>
          <span>Discount Value</span>
          <input
            type="number"
            min="0"
            value={offerForm.discount_value}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, discount_value: e.target.value }))}
            placeholder={offerForm.discount_type === 'percent' ? '10' : '30'}
          />
        </label>

        <label>
          <span>Special Price ₹</span>
          <input
            type="number"
            min="0"
            value={offerForm.addon_special_price}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, addon_special_price: e.target.value }))}
            placeholder="Optional: 49"
          />
        </label>
      </div>

      <div className="ff-days-tools">
        <strong>Active Days</strong>
        <div>
          <button
            type="button"
            onClick={() => setOfferForm((prev) => ({ ...prev, days_active: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] }))}
          >
            Select All
          </button>
          <button
            type="button"
            onClick={() => setOfferForm((prev) => ({ ...prev, days_active: [] }))}
          >
            Clear
          </button>
        </div>
      </div>

      <div className="ff-days-grid">
        {[
          ['mon', 'Mon'],
          ['tue', 'Tue'],
          ['wed', 'Wed'],
          ['thu', 'Thu'],
          ['fri', 'Fri'],
          ['sat', 'Sat'],
          ['sun', 'Sun'],
        ].map(([key, label]) => (
          <button
            type="button"
            key={key}
            className={(offerForm.days_active || []).includes(key) ? 'active' : ''}
            onClick={() => toggleOfferDay(key)}
          >
            <span>{(offerForm.days_active || []).includes(key) ? '✓' : '+'}</span>
            {label}
          </button>
        ))}
      </div>

      <div className="ff-note-box">
        <strong>Preview:</strong> {calculateOffer()}
      </div>
    </div>
  );

  const renderCoinRewardBuilder = () => (
    <div className="ff-offer-builder-section">
      <div className="ff-offer-builder-title green">
        <span>🪙</span>
        <div>
          <h3>Create Coins Reward</h3>
          <p>Customer ke bill amount ka percentage Shop Coins ke roop me reward karein.</p>
        </div>
      </div>

      <div className="ff-form-grid">
        <label>
          <span>Offer Name *</span>
          <input
            value={offerForm.offer_name}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, offer_name: e.target.value }))}
            placeholder="5% Shop Coins Reward"
          />
        </label>

        <label>
          <span>Coins Earn Percentage % *</span>
          <input
            type="number"
            min="0"
            max="100"
            step="0.01"
            value={offerForm.coin_earn_percent}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, coin_earn_percent: e.target.value }))}
            placeholder="5"
          />
        </label>

        <label>
          <span>Minimum Bill for Coins ₹</span>
          <input
            type="number"
            min="0"
            value={offerForm.coin_min_bill_amount}
            onChange={(e) =>
              setOfferForm((prev) => ({
                ...prev,
                coin_min_bill_amount: e.target.value,
                min_purchasing_price: e.target.value,
                min_bill_amount: e.target.value,
              }))
            }
            placeholder="100"
          />
        </label>

        <label>
          <span>Minimum Earn Coins</span>
          <input
            type="number"
            min="0"
            value={offerForm.coin_min_earn}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, coin_min_earn: e.target.value }))}
            placeholder="5"
          />
        </label>

        <label>
          <span>Maximum Earn Coins / Order *</span>
          <input
            type="number"
            min="1"
            value={offerForm.coin_max_earn_per_order}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, coin_max_earn_per_order: e.target.value }))}
            placeholder="150"
          />
        </label>

        <label>
          <span>1 Coin Value ₹ *</span>
          <input
            type="number"
            min="0"
            step="0.01"
            value={offerForm.coin_value_rupees}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, coin_value_rupees: e.target.value }))}
            placeholder="1"
          />
        </label>

        <label>
          <span>Minimum Redeem Coins *</span>
          <input
            type="number"
            min="1"
            value={offerForm.coin_min_redeem}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, coin_min_redeem: e.target.value }))}
            placeholder="50"
          />
        </label>

        <label>
          <span>Maximum Redeem Coins / Order *</span>
          <input
            type="number"
            min="1"
            value={offerForm.coin_max_redeem_per_order}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, coin_max_redeem_per_order: e.target.value }))}
            placeholder="150"
          />
        </label>

        <label>
          <span>Minimum Order for Redeem ₹</span>
          <input
            type="number"
            min="0"
            value={offerForm.coin_min_order_for_redeem}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, coin_min_order_for_redeem: e.target.value }))}
            placeholder="149"
          />
        </label>

        <label>
          <span>Coin Expiry Days *</span>
          <input
            type="number"
            min="1"
            value={offerForm.coin_expiry_days}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, coin_expiry_days: e.target.value }))}
            placeholder="60"
          />
        </label>
      </div>

      <div className="ff-offer-calc-grid">
        <div>
          <span>Example Bill</span>
          <strong>{formatMoney(coinRewardPreview.exampleBill)}</strong>
        </div>

        <div>
          <span>Customer Earn</span>
          <strong className="success">{coinRewardPreview.finalCoins} coins</strong>
        </div>

        <div>
          <span>Coin Value</span>
          <strong>{formatMoney(coinRewardPreview.rewardValue)}</strong>
        </div>
      </div>

      <div className="ff-note-box">
        <strong>Rule:</strong> Customer kisi bhi product par coins use kar sakta hai, lekin minimum redeem coins, maximum redeem coins aur minimum order amount vendor ke rule ke hisab se apply hoga.
      </div>
    </div>
  );

  const renderProgressiveUnlockBuilder = () => (
    <div className="ff-offer-builder-section">
      <div className="ff-offer-builder-title red">
        <span>🚀</span>
        <div>
          <h3>Create Progressive Unlock</h3>
          <p>Bill amount badhne par step-by-step rewards unlock honge.</p>
        </div>
      </div>

      <div className="ff-form-grid">
        <label>
          <span>Offer Name *</span>
          <input
            value={offerForm.offer_name}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, offer_name: e.target.value }))}
            placeholder="Value Ladder Rewards"
          />
        </label>
      </div>

      <div className="ff-progressive-step-list">
        {(offerForm.progressive_steps || []).map((step, index) => (
          <div className="ff-progressive-step-row" key={index}>
            <label>
              <span>Bill Amount ₹</span>
              <input
                type="number"
                min="0"
                value={step.min_bill_amount}
                onChange={(e) => updateProgressiveStep(index, 'min_bill_amount', e.target.value)}
                placeholder={index === 0 ? '300' : '500'}
              />
            </label>

            <label>
              <span>Reward Label</span>
              <input
                value={step.reward_label}
                onChange={(e) => updateProgressiveStep(index, 'reward_label', e.target.value)}
                placeholder={index === 0 ? 'Free Coke' : 'Fries ₹20'}
              />
            </label>

            <label>
              <span>Reward Type</span>
              <select
                value={step.reward_type || 'flat_price'}
                onChange={(e) => updateProgressiveStep(index, 'reward_type', e.target.value)}
              >
                <option value="free">Free</option>
                <option value="flat_price">Special Price ₹</option>
                <option value="discount">Flat Discount ₹</option>
              </select>
            </label>

            <label>
              <span>Reward Product</span>
              <select
                value={step.reward_product_id || ''}
                onChange={(e) => updateProgressiveStep(index, 'reward_product_id', e.target.value)}
              >
                <option value="">Optional product</option>
                {products.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.name} - {formatMoney(product.price)}
                  </option>
                ))}
              </select>
            </label>

            <label>
              <span>Reward Value</span>
              <input
                type="number"
                min="0"
                value={step.reward_value}
                onChange={(e) => updateProgressiveStep(index, 'reward_value', e.target.value)}
                placeholder="0 / 20 / 50"
              />
            </label>

            <button
              type="button"
              className="ff-combo-remove"
              onClick={() => removeProgressiveStep(index)}
              disabled={(offerForm.progressive_steps || []).length <= 1}
            >
              🗑️
            </button>
          </div>
        ))}

        <button type="button" className="ff-light-btn ff-add-combo-item" onClick={addProgressiveStep}>
          + Add Unlock Step
        </button>
      </div>

      <div className="ff-note-box">
        <strong>Preview:</strong> {calculateOffer()}
      </div>
    </div>
  );

  const renderOfferBuilder = () => (
    <form className="ff-card ff-offer-builder-card" onSubmit={handleSubmitOffer}>
      <div className="ff-card-head">
        <div>
          <h2>{offerForm.id ? 'Edit Smart Offer' : 'Create Smart Offer'}</h2>
          <p>Combo, bill unlock add-on aur bill discount same page par manage karein.</p>
        </div>

        <button type="button" className="ff-light-btn" onClick={resetOfferForm}>
          Clear
        </button>
      </div>

      {renderOfferTypeCards()}

      <div className="ff-offer-common-row">
        <label className="ff-check-card ff-offer-active-card">
          <input
            type="checkbox"
            checked={Boolean(offerForm.is_active)}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, is_active: e.target.checked }))}
          />

          <span>
            <strong>Active Offer</strong>
            <small>Customer QR me visible rahega.</small>
          </span>
        </label>

        <label>
          <span>Order Type</span>
          <select
            value={offerForm.order_type}
            onChange={(e) => setOfferForm((prev) => ({ ...prev, order_type: e.target.value }))}
          >
            <option value="individual">Individual</option>
            <option value="group">Group</option>
            <option value="family">Family</option>
          </select>
        </label>
      </div>

      {offerForm.offer_type === 'combo' ? renderComboBuilder() : null}
      {offerForm.offer_type === 'bill_unlock_addon' ? renderAddonBuilder() : null}
      {offerForm.offer_type === 'bill_discount' ? renderBillDiscountBuilder() : null}
      {offerForm.offer_type === 'buy_x_get_y' ? renderBuyXGetYBuilder() : null}
      {offerForm.offer_type === 'time_slot_offer' ? renderTimeSlotOfferBuilder() : null}
      {offerForm.offer_type === 'progressive_unlock' ? renderProgressiveUnlockBuilder() : null}
      {offerForm.offer_type === 'coin_reward' ? renderCoinRewardBuilder() : null}

      <div className="ff-offer-preview">
        <span>Customer Preview</span>
        <strong>{calculateOffer()}</strong>
      </div>

      <div className="ff-form-actions">
        <button type="submit" className="ff-primary-btn" disabled={savingOffer}>
          {savingOffer ? 'Saving...' : offerForm.id ? 'Update Offer' : 'Save Offer'}
        </button>

        <button type="button" className="ff-light-btn" onClick={resetOfferForm}>
          Clear
        </button>
      </div>
    </form>
  );

  const getOfferCardDetails = (offer) => {
    const normalized = normalizeOfferFromApi(offer);
    const type = normalized.offer_type || 'bill_discount';
    const safety = getOfferSafetyFromOffer(normalized);
    const active = safeFlagToBool(normalized.is_active ?? true, true);

    if (type === 'combo') {
      const items = Array.isArray(normalized.combo_items) ? normalized.combo_items : [];
      const actual = toNumber(normalized.actual_price, 0) || items.reduce((sum, item) => {
        return sum + toNumber(item.price, 0) * toNumber(item.quantity, 1);
      }, 0);
      const price = toNumber(normalized.combo_price, 0);
      const save = Math.max(0, actual - price);

      return {
        icon: '🍔🥤',
        title: normalized.offer_name || normalized.combo_name || 'Combo Set',
        typeLabel: 'Combo Set',
        typeClass: 'combo',
        line1: `Actual ${formatMoney(actual)} | Offer ${formatMoney(price)} | Save ${formatMoney(save)}`,
        line2: items.map((item) => `${item.name || 'Item'} x${item.quantity || 1}`).join(', '),
        active,
        safety,
      };
    }

    if (type === 'bill_unlock_addon') {
      const product = getProductById(normalized.addon_product_id);
      return {
        icon: '🍕',
        title: normalized.offer_name || 'Bill Unlock Add-on',
        typeLabel: 'Bill Unlock Add-on',
        typeClass: 'addon',
        line1: `Unlock Bill ${formatMoney(normalized.min_purchasing_price || normalized.min_bill_amount)}+ | Original ${formatMoney(normalized.addon_original_price || product?.price)} | Deal ${formatMoney(normalized.addon_special_price)}`,
        line2: `${normalized.addon_product_name || product?.name || 'Selected Product'} | Limit ${normalized.limit_per_order || 1}`,
        active,
        safety,
      };
    }

    if (type === 'buy_x_get_y') {
      const buyProduct = getProductById(normalized.buy_product_id);
      const getProduct = getProductById(normalized.get_product_id);
      const rewardText = normalized.reward_type === 'free'
        ? 'Free'
        : normalized.reward_type === 'percent_discount'
          ? `${normalized.reward_value || 0}% OFF`
          : `${formatMoney(normalized.reward_value || 0)}`;

      return {
        icon: '🎁',
        title: normalized.offer_name || 'Buy X Get Y',
        typeLabel: 'Buy X Get Y',
        typeClass: 'buyget',
        line1: `Buy ${normalized.buy_quantity || 1} ${normalized.buy_product_name || buyProduct?.name || 'item'}`,
        line2: `Get ${normalized.get_quantity || 1} ${normalized.get_product_name || getProduct?.name || 'item'} ${rewardText}`,
        active,
        safety: { safe: true },
      };
    }

    if (type === 'time_slot_offer') {
      return {
        icon: '⏰',
        title: normalized.offer_name || 'Time Slot Offer',
        typeLabel: 'Time Slot',
        typeClass: 'time',
        line1: `${formatTimeAmPm(normalized.start_time)} - ${formatTimeAmPm(normalized.end_time)}`,
        line2: `${(normalized.days_active || []).join(', ') || 'All days'} • ${formatOfferForDisplay(normalized.offer_text)}`,
        active,
        safety: { safe: true },
      };
    }

    if (type === 'progressive_unlock') {
      const steps = Array.isArray(normalized.progressive_steps) ? normalized.progressive_steps : [];
      return {
        icon: '🚀',
        title: normalized.offer_name || 'Progressive Unlock',
        typeLabel: 'Progressive',
        typeClass: 'progressive',
        line1: `${steps.length} unlock steps`,
        line2: steps.map((step) => `${formatMoney(step.min_bill_amount)} → ${step.reward_label}`).join(' | '),
        active,
        safety: { safe: true },
      };
    }

    if (type === 'coin_reward') {
      const coinConfig = getCoinRewardConfig(normalized);

      return {
        icon: '🪙',
        title: normalized.offer_name || 'Coins Reward',
        typeLabel: 'Coins Reward',
        typeClass: 'coins',
        line1: `${coinConfig.coin_earn_percent}% coins on bill ${formatMoney(coinConfig.coin_min_bill_amount)}+ | Min earn ${coinConfig.coin_min_earn} | Max earn ${coinConfig.coin_max_earn_per_order}`,
        line2: `Redeem min ${coinConfig.coin_min_redeem}, max ${coinConfig.coin_max_redeem_per_order}/order • Min order ${formatMoney(coinConfig.coin_min_order_for_redeem)} • 1 coin = ${formatMoney(coinConfig.coin_value_rupees)}`,
        active,
        safety: { safe: true },
      };
    }

    return {
      icon: '🏷️',
      title: normalized.offer_name || 'Bill Discount',
      typeLabel: 'Bill Discount',
      typeClass: 'discount',
      line1: `Bill ${formatMoney(normalized.min_purchasing_price || normalized.min_bill_amount)}+ | ${
        normalized.discount_type === 'percent'
          ? `${normalized.discount_value || 0}% off`
          : `${formatMoney(normalized.discount_value || 0)} off`
      }`,
      line2: normalized.max_discount ? `Max ${formatMoney(normalized.max_discount)}` : formatOfferForDisplay(normalized.offer_text),
      active,
      safety,
    };
  };

  const renderSavedOffers = () => (
    <section className="ff-card ff-smart-offer-list-card">
      <div className="ff-card-head">
        <div>
          <h2>Saved Offers List</h2>
          <p>Offer status, safety aur action buttons yahin se manage karein.</p>
        </div>

        <button type="button" className="ff-light-btn" onClick={fetchOffers}>
          Refresh
        </button>
      </div>

      {loadingOffers ? (
        <div className="ff-empty-state">Offers loading...</div>
      ) : offers.length === 0 ? (
        <div className="ff-empty-state">Offer nahi hai. Pehla combo ya discount create karein.</div>
      ) : (
        <div className="ff-smart-offer-list">
          {offers.map((offer) => {
            const detail = getOfferCardDetails(offer);

            return (
              <div key={offer.id} className="ff-smart-offer-row">
                <div className="ff-smart-offer-icon">{detail.icon}</div>

                <div className="ff-smart-offer-main">
                  <div className="ff-smart-offer-title">
                    <h3>{detail.title}</h3>
                    <span className={`ff-offer-type-pill ${detail.typeClass}`}>{detail.typeLabel}</span>
                  </div>

                  <p>{detail.line1}</p>
                  <small>{detail.line2}</small>
                </div>

                <div className="ff-smart-offer-badges">
                  <span className={detail.active ? 'ff-status-pill success' : 'ff-status-pill warning'}>
                    {detail.active ? 'Active' : 'Paused'}
                  </span>

                  <span className={detail.safety.safe ? 'ff-status-pill success' : 'ff-status-pill danger'}>
                    {detail.safety.safe ? 'Safe' : 'Unsafe'}
                  </span>
                </div>

                <div className="ff-smart-offer-actions">
                  <button type="button" onClick={() => startEditOffer(offer)}>
                    ✏️ Edit
                  </button>

                  <button type="button" onClick={() => handleToggleOfferStatus(offer)}>
                    {detail.active ? '⏸️ Pause' : '▶️ Resume'}
                  </button>

                  <button type="button" className="danger" onClick={() => handleDeleteOffer(offer.id)}>
                    🗑️ Delete
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );

  const renderCustomerOfferPreview = () => (
    <aside className="ff-card ff-offer-preview-side">
      <div className="ff-card-head">
        <div>
          <h2>Customer QR Preview</h2>
          <p>Customer ko offers kuch aise dikhenge.</p>
        </div>
      </div>

      <div className="ff-phone-preview">
        <div className="ff-phone-top">
          <span>9:41</span>
          <b>📶 🔋</b>
        </div>

        <div className="ff-phone-shop">
          <div>🍔</div>
          <div>
            <strong>Tasty Bites</strong>
            <small>Scan • Order • Enjoy</small>
          </div>
          <span>▦</span>
        </div>

        <h4>Combo Offers</h4>

        <div className="ff-phone-offer-card combo">
          <span>🍔🍟🥤</span>
          <div>
            <strong>Burger Meal Combo</strong>
            <small>Burger + Fries + Coke</small>
            <p>
              <b>₹199</b> <del>₹260</del> <em>Save ₹61</em>
            </p>
            <button>+ Add Combo</button>
          </div>
        </div>

        <div className="ff-phone-offer-card addon">
          <span>🍕</span>
          <div>
            <strong>Pizza only ₹50</strong>
            <small>On orders above ₹500</small>
            <p>
              <b>₹50</b> <del>₹150</del> <em>Save ₹100</em>
            </p>
            <button>+ Add Deal</button>
          </div>
        </div>

        <div className="ff-phone-offer-card locked">
          <span>🥖</span>
          <div>
            <strong>Locked Deal</strong>
            <small>Add ₹120 more to unlock Garlic Bread</small>
          </div>
        </div>

        <div className="ff-phone-cart">
          <strong>Your Cart</strong>
          <span>2 items</span>
          <b>₹249</b>
        </div>

        <button className="ff-phone-review-btn">🛒 Review Cart</button>
      </div>

      <div className="ff-loss-rules-card">
        <h3>🛡️ Loss-Proof Rules</h3>

        <div>
          <span>Minimum Bill</span>
          <small>Offer unlock bill amount ke baad</small>
        </div>

        <div>
          <span>Cost Price Check</span>
          <small>Offer price cost se neeche nahi</small>
        </div>

        <div>
          <span>Safe Margin</span>
          <small>Minimum margin protect hota hai</small>
        </div>

        <div>
          <span>Limit Per Order</span>
          <small>Usage limit control</small>
        </div>
      </div>
    </aside>
  );

  const renderOffersTab = () => (
    <div className="ff-smart-offers-page">
      {renderOfferDashboard()}

      <div className="ff-offer-workspace">
        <div className="ff-offer-left-area">
          {renderOfferBuilder()}
          {renderSavedOffers()}
        </div>

        {renderCustomerOfferPreview()}
      </div>

      <div className="ff-note-box ff-offer-footer-note">
        <strong>Smart Offers:</strong> Is frontend me Combo Set, Bill Unlock Add-on aur Bill Discount ka UI ready hai.
        Backend me offer_type, combo_items, combo_price, addon fields aur safety fields save karne ke liye route/schema update karna padega.
      </div>
    </div>
  );

  const renderSettingsTab = () => (
    <section className="ff-card ff-settings-card">
      <div className="ff-card-head">
        <div>
          <h2>Fast Food Settings</h2>
          <p>Dine-in, takeaway, delivery, payment aur shop timing DB me save hoga.</p>
        </div>

        <button type="button" className="ff-light-btn" onClick={fetchSettings} disabled={savingSettings}>
          Refresh
        </button>
      </div>

      <div className="ff-note-box ff-settings-live-note">
        <strong>Current Timing:</strong> {getTimingPreview(settings)}
      </div>

      <div className="ff-settings-grid">
        <label className="ff-check-card">
          <input
            type="checkbox"
            checked={settings.enable_dine_in}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                enable_dine_in: e.target.checked,
              }))
            }
          />

          <span>
            <strong>Dine-in</strong>
            <small>Customer table par order kar sakta hai.</small>
          </span>
        </label>

        <label className="ff-check-card">
          <input
            type="checkbox"
            checked={settings.enable_takeaway}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                enable_takeaway: e.target.checked,
              }))
            }
          />

          <span>
            <strong>Takeaway</strong>
            <small>Customer pickup order de sakta hai.</small>
          </span>
        </label>

        <label className="ff-check-card">
          <input
            type="checkbox"
            checked={settings.enable_delivery}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                enable_delivery: e.target.checked,
              }))
            }
          />

          <span>
            <strong>Delivery</strong>
            <small>Home delivery option dikhana hai.</small>
          </span>
        </label>

        <label className="ff-check-card">
          <input
            type="checkbox"
            checked={settings.allow_cod}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                allow_cod: e.target.checked,
              }))
            }
          />

          <span>
            <strong>COD / Counter Pay</strong>
            <small>Cash on delivery / counter payment.</small>
          </span>
        </label>

        <label className="ff-check-card">
          <input
            type="checkbox"
            checked={settings.allow_online_payment}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                allow_online_payment: e.target.checked,
              }))
            }
          />

          <span>
            <strong>Online Payment</strong>
            <small>UPI/Card/Razorpay payment allow.</small>
          </span>
        </label>
      </div>

      <div className="ff-settings-section-title">
        <h3>Charges & Minimum Order</h3>
        <p>Ye values QR customer flow me use hongi.</p>
      </div>

      <div className="ff-form-grid">
        <label>
          <span>Preparation Time (minutes)</span>
          <input
            type="number"
            min="0"
            value={settings.preparation_time}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                preparation_time: e.target.value,
              }))
            }
            placeholder="20"
          />
        </label>

        <label>
          <span>Minimum Order ₹</span>
          <input
            type="number"
            min="0"
            value={settings.min_order_amount}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                min_order_amount: e.target.value,
              }))
            }
            placeholder="0"
          />
        </label>

        <label>
          <span>Packaging Fee ₹</span>
          <input
            type="number"
            min="0"
            value={settings.packaging_fee}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                packaging_fee: e.target.value,
              }))
            }
            placeholder="0"
          />
        </label>

        <label>
          <span>Delivery Fee ₹</span>
          <input
            type="number"
            min="0"
            value={settings.delivery_fee}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                delivery_fee: e.target.value,
              }))
            }
            placeholder="0"
          />
        </label>
      </div>

      <div className="ff-settings-section-title">
        <h3>Delivery & Timing</h3>
        <p>Time input 24-hour format me select hota hai, preview AM/PM me dikhega.</p>
      </div>

      <div className="ff-form-grid">
        <label>
          <span>Delivery Radius (KM)</span>
          <input
            type="number"
            min="0"
            step="0.1"
            value={settings.delivery_radius_km}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                delivery_radius_km: e.target.value,
              }))
            }
            placeholder="Example: 5"
          />
        </label>

        <label>
          <span>Delivery ETA Min</span>
          <input
            type="number"
            min="0"
            value={settings.delivery_eta_min}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                delivery_eta_min: e.target.value,
              }))
            }
            placeholder="30"
          />
        </label>

        <label>
          <span>Delivery ETA Max</span>
          <input
            type="number"
            min="0"
            value={settings.delivery_eta_max}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                delivery_eta_max: e.target.value,
              }))
            }
            placeholder="60"
          />
        </label>
      </div>

      <div className="ff-time-grid">
        <label className="ff-time-card ff-time-card-ampm">
          <span>Opening Time</span>
          <TimeAmPmInput
            value={settings.shop_open_time || settings.opening_time || ''}
            onChange={(value) => {
              setSettings((prev) => ({
                ...prev,
                shop_open_time: value,
                opening_time: value,
              }));
            }}
          />
          <small>{formatTimeAmPm(settings.shop_open_time || settings.opening_time)}</small>
        </label>

        <label className="ff-time-card ff-time-card-ampm">
          <span>Closing Time</span>
          <TimeAmPmInput
            value={settings.shop_close_time || settings.closing_time || ''}
            onChange={(value) => {
              setSettings((prev) => ({
                ...prev,
                shop_close_time: value,
                closing_time: value,
              }));
            }}
          />
          <small>{formatTimeAmPm(settings.shop_close_time || settings.closing_time)}</small>
        </label>
      </div>

      <div className="ff-form-actions">
        <button type="button" className="ff-primary-btn" onClick={saveSettings} disabled={savingSettings}>
          {savingSettings ? 'Saving...' : 'Save Settings to DB'}
        </button>

        <button type="button" className="ff-light-btn" onClick={() => setSettings(defaultSettings)} disabled={savingSettings}>
          Reset
        </button>
      </div>

      <div className="ff-note-box ff-settings-save-note">
        <strong>Saved in DB:</strong> Ye settings <code>/api/order-settings?userdb=true</code> par save/read hongi.
        QR customer page me Dine-in, Takeaway, Delivery, Payment aur Timing isi se control hoga.
      </div>
    </section>
  );

  const renderMainContent = () => {
    if (activeTab === 'home') return renderHome();
    if (activeTab === 'products') return renderProductsTab();
    if (activeTab === 'menu') return renderMenuList();
    if (activeTab === 'offers') return renderOffersTab();
    if (activeTab === 'settings') return renderSettingsTab();

    return renderHome();
  };

  return (
    <div className="fast-food-page-with-dashboard">
      <Dashboard />

      <div className="ff-page-shell">
        {renderSidebar()}

        <main className="ff-main">
          {renderTopHeader()}

          {toast ? <div className="ff-toast">{toast}</div> : null}

          {renderMainContent()}
        </main>

        {renderMobileBottomNav()}
      </div>
    </div>
  );
}

export default FastFoodPage;
